<template>
  <v-card id="widget" class="widget-card" :height="widgetHeight" flat  >
    <div class="widget-header" :style="{'backgroundColor': primaryColor}">
      <div class="widget-header-inner">
        <div class="widget-header-previous">
          <v-btn v-if="step > 0 && step != 5 && step != 6 && step != 7 && step != 8 && step != 9" icon dark class="ma-0 pa-0" @click="stepBack()" >
              <v-icon dark color="white">mdi-chevron-left</v-icon>
            </v-btn>
        </div>
        <div class="widget-header-title">
          <h2 style="text-align: center" class="step-title white--text">{{ steps[step].name[selectedLanguage.id] }}</h2>
        </div>
        <div class="widget-header-language">
          <v-menu 
            offset-y 
            transition="slide-y-transition"
            bottom
            content-class="custom-shape-menu"
            >
              <template v-slot:activator="{ on, attrs }">
                <div
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-0 selected-language widget-language-flag"
                  :class="selectedLanguage.id" 
                >
                 
                </div>
              </template>
              <v-list dense class="pa-0 ma-0">
                <v-list-item class="my-0 py-0"
                  v-for="(language, index) in widgetLanguages"
                  :key="index"
                  @click="selectedLanguage = language, setSelectedLanguage()"
                  >
                  <v-list-item-title class="ma-0 pa-0">
                    <div
                      class="widget-language-flag list"
                      :class="language.id" 
                    >
                    </div>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
        </div>
        <div class="widget-header-close">
          <v-btn icon dark @click="closeWidget()">
            <v-icon dark color="white">mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
    </div>

    <div id="widget-content" class="widget-content" :class="{'remove-padding': showTerms}" :style="{height: widgetContentHeight + 'px'}">      
      <v-alert v-if="feedback.message" class="ma-0 pa-2" style="border-radius: 0" text outlined :icon="feedback.icon" :type="feedback.type">{{ feedback.message }}</v-alert>

      <v-dialog
        attach="#widget" 
        v-model="widgetSettings.notification.show"
        persistent
        fullscreen
        scrollable
        hide-overlay
      >
      <v-card>
        <v-card-title class="pr-2 title-primary">
          <div class="notification-header-title">
          <h2 style="text-align: center" class="step-title white--text">{{ widgetSettings.notification.messageTitle[selectedLanguage.id] }}</h2>
        </div>

        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-4" v-html="widgetSettings.notification.message[selectedLanguage.id]"></v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
          block
            color="secondary"
            rounded
            @click="widgetSettings.notification.show = false"
          >
            {{ $t('basicdictionary.continue') }}
          </v-btn>
        </v-card-actions>
      </v-card>
      </v-dialog>

      <div  class="valid-info" v-if="!error.active">
        <div class="step-0" v-if="step == 0 && !showTerms">
          <!-- <p class="text-center pa-3 ma-0" style="background-color: #f4f5fa; font-size: 16px;">{{ $t('clientInfodesc') }}</p> -->
          <div class="pre-selected-treatment-wrapper" v-if="preSelectedTreatmentData">
            <p class="mb-2"><i>{{ $t('chosenTreatment') }}:</i></p>
            <h3>{{ preSelectedTreatmentData.treatmentTitle }}</h3>
            <p>{{ preSelectedTreatmentData.treatmentDesc }}</p>
            <p class="pre-selected-treatment-time">{{ preSelectedTreatmentData.treatmentTime }} {{ $t('minutes') }}</p>
          </div>
          <div style="padding: 20px 20px 100px 20px;">
            <v-form ref="clientInformationForm" v-model="clientInformationValid">
              <v-container grid-list-md  class="pa-0 ma-0">
                <v-layout row wrap class="ma-0 pa-0">
                  <v-flex xs6>
                    <v-text-field
                      outlined
                      v-model="firstName"
                      :counter="30"
                      :rules="nameRules"
                      :label="$t('firstName')"
                      required
                      class="mt-2"
                      background-color="background"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      outlined
                      v-model="lastName"
                      :counter="30"
                      :rules="nameRules"
                      :label="$t('lastName')"
                      required
                      class="mt-2"
                      background-color="background"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      outlined
                      v-model="email"
                      :rules="emailRules"
                      label="E-mail"
                      required
                      background-color="background"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm5 xs12>

                    <v-select
                      outlined
                      hide-details
                      class="pa-0 ma-0 phone-lang-select"
                      content-class="pa-0 ma-0"
                      :items="languages"
                      v-model="selectedPhoneLanguage"
                      background-color="background"
                      item-text="item"
                      >
                      <template slot="selection" slot-scope="data" class="ma-0 pa-0">
                        <country-flag :country="data.item.id" />
                        <span>{{ data.item.phone }}</span>
                      </template>
                      <template slot="item" slot-scope="data">
                        <country-flag :country="data.item.id" />
                        <span >{{ data.item.phone }}</span>
                      </template>
                    </v-select>
                  </v-flex>
                  <v-flex sm7 xs12>
                    <v-text-field
                      outlined
                      v-model="tel"
                      :counter="9"
                      :rules="telRules"
                      :label="$t('telephone')"
                      required
                      background-color="background"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-checkbox 
                      v-model="terms"
                      hide-details
                      required
                      :rules="checkRules"
                      class="ma-0 pa-0"
                      >
                      <template v-slot:label>
                        <span>{{ $t('iAgreeWithThe') }} <a @click="showTerms = true">{{ $t('termsAgree') }}</a></span>
                      </template>
                    </v-checkbox>
                    <v-checkbox
                      v-model="saveClientInformation"
                      hide-details
                      class="ma-0 my-3 pa-0"
                      >
                      <template v-slot:label>
                        <div>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <span v-on="on">
                                {{ $t('saveMyDataLocaly') }} <v-icon small>mdi-help-circle</v-icon>
                              </span>
                            </template>
                            {{ $t('saveMyDataLocalyExplain') }}
                          </v-tooltip>
                        </div>
                      </template>
                      </v-checkbox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </div>
        </div>


        <div v-if="step == 0 && showTerms" class="terms-wrapper">
          <div class="terms-header clear">
            <div style="padding: 8px; display: inline-block"><strong>{{ $t('terms') }}</strong></div>
            <v-btn style="float:right;" icon dark @click="showTerms = false" class="pa-0 ma-1">
              <v-icon dark color="white">mdi-close</v-icon>
            </v-btn>
          </div>
          <div class="terms-content" :style="{ height: (widgetContentHeight - 50) + 'px'}" v-html="bookingTerms[selectedLanguage.id]"></div>
        </div>

        <div v-if="step == 1">
          <p class="text-center pa-3 ma-0" style="background-color: #f4f5fa; font-size: 16px;">{{ $t('branchdesc') }}</p>
          <v-list v-if="!loadingCompData" class="pa-0 ma-0">
            <v-list-item class="widget-list" :class="{selected: branch.selected}" v-for="(branch,i) in branches" :key="i" @click="selectBranch( branch)">
              <v-list-item-avatar class="grey lighten-3">
                  <v-img v-if="branch.branchphoto" :src="branch.branchphoto"></v-img>
                  <v-icon v-else :color="secondaryColor">mdi-domain</v-icon>
                </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title> {{ compdata.name }} - {{ branch.name }}</v-list-item-title>
                <v-list-item-subtitle>{{ branch.branchAddress.address }} {{ branch.branchAddress.nr }}, {{ branch.branchAddress.postalCode }} {{ branch.branchAddress.city }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <div v-else class="text-center" style="padding: 50px 10px 10px 10px;">
            <v-progress-circular
              :size="50"
              :color="primaryColor"
              indeterminate
            ></v-progress-circular>
          </div>
        </div>

         <div class="step-2" v-if="step == 2">
           <!-- <p class="text-center pa-3 ma-0" style="background-color: #f4f5fa; font-size: 16px;">{{ $t('treatmentdesc') }}</p> -->
          <div class="treatments" :class="{'selected': treatmentSelected}" v-if="!loadingTreatments">
            <div class="pa-3" style="background-color: #f6f7fb">
              <v-text-field
                outlined
                v-model="treatmentSearch"
                clearable
                rounded
                dense
                hide-details
                :placeholder="$t('searchTreatments')"
                background-color="menu"
              ></v-text-field>
            </div>

            <div class="treatment-list-by-type" v-if="!treatmentSearch || treatmentSearch.length == 0">
              <v-container v-if="seperateTreatments" grid-list-md class="py-3 px-2 ma-0">
                <v-layout row wrap class="ma-0 pa-0" >
                  <v-flex md4>
                    <v-btn block depressed :color="primaryColor" :outlined="buttonColorAll" :dark="!buttonColorAll" @click="selectedGender = 'all'">{{ $t('all') }}</v-btn>
                  </v-flex>
                  <v-flex md4>
                    <v-btn block depressed :color="primaryColor"  :outlined="buttonColorFemale" :dark="!buttonColorFemale" @click="selectedGender = 'female'">{{ $t('woman') }}</v-btn>
                  </v-flex>
                  <v-flex md4>
                    <v-btn block depressed :color="primaryColor"  :outlined="buttonColorMale" :dark="!buttonColorMale" @click="selectedGender = 'male'">{{ $t('man') }}</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>

              <p v-if="treatmentTypes.length == 0" class="text-center pa-4 ma-0" style="font-size: 16px;">{{ $t('notreatments') }}</p>
              <v-divider></v-divider>

              <v-list 
                class="pa-0 ma-0"
                two-line
                flat
                >
                <v-list-item-group
                  v-for="(treatmentType, index) in treatmentTypesFiltered" :key="treatmentType.id"
                  multiple
                >
                <div class="treatment-type-title">
                  <h3>{{ treatmentType.name }} </h3>
                </div>
                <v-list-item class="treatment-list" :class="{selected: treatment.selected}" v-for="(treatment,i) in treatmentType.treatments" :key="i" @click="selectTreatment('treatment', treatment, i, index)">
                  <v-list-item-action v-if="treatment.type == 'treatment' && !treatment.eventBooking" class="mr-4">
                    <v-icon v-if="treatment.selected" :color="primaryColor" size="30">mdi-checkbox-marked-circle</v-icon>
                    <v-icon :color="primaryColor" size="30" v-else>mdi-checkbox-blank-circle-outline</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      <strong>{{ treatment.treatmentTitle }}</strong>
                    </v-list-item-title>
                    <v-list-item-subtitle class="treatment-description">{{ treatment.treatmentShortDesc }}</v-list-item-subtitle>

                    <v-list-item-subtitle v-if="treatment.type != 'event'" class="treatment-time">{{ treatment.treatmentTime }} {{ $t('minutes') }} </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      <v-chip v-if="treatment.type == 'event' && treatment.events && treatment.events.length > 0" :color="primaryColor" small class="white--text ma-0">
                        <div class="white--text" v-if="treatment.events.length == 1"><strong>{{ treatment.events.length }} {{ $t('availabilityDay') }}</strong></div>
                        <div class="white--text" v-else><strong>{{ treatment.events.length }} {{ $t('availabilityDays') }}</strong></div>
                      </v-chip>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action-text v-if="showPrices">
                    <span class="treatment-price" v-if="treatment.treatmentPrice">
                      {{ numberWithCommas(treatment.treatmentPrice) }}
                    </span>
                    <span class="treatment-price empty"  v-else>-</span>
                  </v-list-item-action-text>
                </v-list-item>
                </v-list-item-group>
              </v-list>
              <v-list 
                v-if="events.length > 0"
                class="pa-0 ma-0"
                two-line
                flat
                >
                <v-list-item-group multiple>
                  <div class="treatment-type-title">
                    <h3>Events</h3>
                  </div>
                    <v-list-item class="treatment-list"  v-for="(event,i) in events" :key="i" :class="{'selected': event.selected}" @click="selectTreatment('event', event, i, null)">
                      <v-list-item-content>
                        <v-list-item-title>
                          <strong>{{ event.title }}</strong>
                        </v-list-item-title>
                        <v-list-item-subtitle>{{ event.description }}</v-list-item-subtitle>
                        <v-list-item-subtitle>
                          <v-chip v-if="event.events && event.events.length > 0" :color="primaryColor" small class="white--text ma-0">
                            <div class="white--text" v-if="event.events.length == 1"><strong>{{ event.events.length }} {{ $t('availabilityDay') }}</strong></div>
                            <div class="white--text" v-else><strong>{{ event.events.length }} {{ $t('availabilityDays') }}</strong></div>
                          </v-chip>
                        </v-list-item-subtitle>
                        
                      </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>
              </v-list>
            </div>

            <div class="treatment-list-by-search" v-else>
              <v-list class="pa-0 ma-0" flat>
                <v-list-item two-line class="treatment-list" :class="{selected: treatment.selected}" v-for="(treatment,i) in treatmentTypesFiltered.treatments" :key="i" @click="selectTreatment('treatment', treatment,i, null)">
                  <v-list-item-action v-if="treatment.type == 'treatment'" class="mr-4">
                    <v-icon v-if="treatment.selected" :color="primaryColor" size="30">mdi-checkbox-marked-circle</v-icon>
                    <v-icon :color="primaryColor" size="30" v-else>mdi-checkbox-blank-circle-outline</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      <strong>{{ treatment.treatmentTitle }}</strong>
                    </v-list-item-title>
                    <v-list-item-subtitle class="treatment-description">{{ treatment.treatmentShortDesc }}</v-list-item-subtitle>

                    <v-list-item-subtitle v-if="treatment.type != 'event'" class="treatment-time">{{ treatment.treatmentTime }} {{ $t('minutes') }} </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      <v-chip v-if="treatment.type == 'event' && treatment.events && treatment.events.length > 0" :color="primaryColor" small class="white--text ma-0">
                        <div class="white--text" v-if="treatment.events.length == 1"><strong>{{ treatment.events.length }} {{ $t('availabilityDay') }}</strong></div>
                        <div class="white--text" v-else><strong>{{ treatment.events.length }} {{ $t('availabilityDays') }}</strong></div>
                      </v-chip>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action-text v-if="showPrices">
                    <span class="treatment-price" v-if="treatment.treatmentPrice">
                      &euro; {{ numberWithCommas(treatment.treatmentPrice) }}
                    </span>
                    <span class="treatment-price empty"  v-else>-</span>
                  </v-list-item-action-text>
                </v-list-item>
              </v-list>
              <v-list 
                v-if="treatmentTypesFiltered.events.length > 0"
                class="pa-0 ma-0"
                two-line
                >
                <v-list-item-group multiple>
                  <div class="treatment-type-title">
                    <h3>Events</h3>
                  </div>
                    <v-list-item class="treatment-list" :class="{selected: event.selected}" v-for="(event,i) in treatmentTypesFiltered.events" :key="i" @click="selectTreatment('event', event, i, null)">
                      <v-list-item-content>
                        <v-list-item-title>
                          <strong>{{ event.title }}</strong>
                        </v-list-item-title>
                        <v-list-item-subtitle>{{ event.description }}</v-list-item-subtitle>
                        <v-list-item-subtitle>
                          <v-chip v-if="event.events && event.events.length > 0" :color="primaryColor" small class="white--text ma-0">
                            <div class="white--text" v-if="event.events.length == 1"><strong>{{ event.events.length }} {{ $t('availabilityDay') }}</strong></div>
                            <div class="white--text" v-else><strong>{{ event.events.length }} {{ $t('availabilityDays') }}</strong></div>
                          </v-chip>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>
              </v-list>
            </div>
          </div>

          <div v-else class="text-center" style="padding: 50px 10px 10px 10px;">
            <v-progress-circular
              :size="50"
              :color="secondaryColor"
              indeterminate
            ></v-progress-circular>
          </div>
        </div>

        <div class="step-3" v-if="step == 3">
          <div v-if="!selectedTreatment.event" class="date-select-treatments">
            <div v-if="!selectedTreatment.eventBooking" class="date-select-header" :class="dateview">
              <v-select
                v-if="!selectedTreatment.noEmployeeSubtreatment"
                rounded
                outlined
                :label="$t('preferenceForPractitioner')"
                hide-details
                :items="employees"
                v-model="selectedEmployee"
                background-color="menu"
                item-text="name"
                item-value="id"
                @input="selectEmployee()"
                >
                <template slot="selection" slot-scope="data" class="ma-0 pa-0">
                  <v-avatar color="#f9f9f9" size="36px" class="mr-2">
                    <img v-show="data.item.photo && data.item.photoLoaded" :src="data.item.photo" @load="loaded(data.item.id)">
                    <v-icon v-show="!data.item.photo || !data.item.photoLoaded">
                      mdi-account
                    </v-icon>
                  </v-avatar>
                  <span >{{ data.item.name }}</span>
                </template>
                <template slot="item" slot-scope="data">
                  <v-avatar color="#f9f9f9" size="36px" class="mr-2">
                    <img v-show="data.item.photo && data.item.photoLoaded" :src="data.item.photo" @load="loaded(data.item.id)">
                    <v-icon v-show="!data.item.photo || !data.item.photoLoaded">
                      mdi-account
                    </v-icon>
                  </v-avatar>
                  <span>{{ data.item.name }}</span>
                </template>
              </v-select>
            </div>

            <div v-else class="event-availability-heading">
              <h2>{{ selectedTreatment.eventBookingData.treatmentTitle }}</h2>
              <p class="ma-0">{{ selectedTreatment.eventBookingData.treatmentShortDesc }}</p>
            </div>

            <div v-if="availabilityLoading" class="text-center" style="padding: 50px 10px 10px 10px;">
              <v-progress-circular
                :size="50"
                :color="secondaryColor"
                indeterminate
              ></v-progress-circular>
            </div>
            <div v-show="!availabilityLoading" class="widget-date-time-wrapper">
              <div v-if="dateview == 'carousel'" class="widget-dates-outer-wrapper" :style="{'width': datesFitWidth + 'px'}">
                <div class="widget-dates-previous">
                  <v-btn
                    @click="availabilityPrevious()"
                    class="ml-1"
                    text
                    :disabled="availabilityMargin === 0"
                    small
                    icon
                    color="#c1c9d7"
                    >
                    <v-icon button >mdi-chevron-left</v-icon>
                  </v-btn>
                </div>
                <div id="widget-dates-wrapper">
                  <div class="widget-dates" :style="[ {width: (availability.length * 65) + 'px'}, { marginLeft: availabilityMargin + 'px'}]">
                    <a v-for="(date, index) in availability" :key="index" class="date-item"  @click="!!date.thriveSlots.length > 0 && selectDate(index)" :class="[{ 'today' : date.thriveDate == today}, {'selected' : date.selected}, {'empty' : date.thriveSlots.length == 0}]">
                      <div class="day-text">{{ date.thriveDate | moment("ddd" )}}</div>
                      <div class="day-number">{{ date.thriveDate | moment("D") }}</div>
                      <div class="month">{{ date.thriveDate | moment("MMM") }}</div>
                    </a>
                  </div>
                </div>
                <div class="widget-dates-next">
                  <v-btn
                    @click="availabilityNext()"
                    class="mr-1"
                    text
                    small
                    :disabled="noMoreDates"
                    icon
                    color="#c1c9d7"
                    >
                    <v-icon button >mdi-chevron-right</v-icon>
                  </v-btn>
                </div>
              </div>


              <div v-if="dateview == 'month'" class="widget-dates-outer-wrapper" :style="{'width': datesFitWidth + 'px'}">
                <div class="widget-dates-monthview-header">
                  <div class="widget-dates-previous">
                    <v-btn
                      v-if="showingMonthIsNotCurrentMonth"
                      @click="availabilityPrevious()"
                      class="ml-1"
                      text
                      small
                      icon
                      color="#c1c9d7"
                      >
                      <v-icon button >mdi-chevron-left</v-icon>
                    </v-btn>
                  </div>
                  <div class="widget-view-month"> {{ activeMonth }}</div>
                  <div class="widget-dates-next">
                    <v-btn
                      @click="availabilityNext()"
                      class="mr-1"
                      text
                      small
                      :disabled="availabilityLoadingExtra"
                      :loading="availabilityLoadingExtra"
                      icon
                      color="#c1c9d7"
                      >
                      <v-icon button >mdi-chevron-right</v-icon>
                    </v-btn>
                  </div>
                </div>

                <div class="widget-dates-monthview-dates">
                  <a v-for="(date, index) in availabilityMonth" :key="index" class="date-item"  @click="!!date.thriveSlots.length > 0 && selectDate(index)" :class="[{ 'today' : date.thriveDate == today}, {'selected' : date.selected}, {'empty' : date.thriveSlots.length == 0}]">
                    <div class="day-text">{{ date.thriveDate | moment("ddd" )}}</div>
                    <div class="day-number">{{ date.thriveDate | moment("D") }}</div>
                  </a>
                </div>
                
              </div>

              <p class="first-possibility"  v-if="!selectedDate && firstPossibleDay">
                {{ $t('firstPossibility') }} <span class="first-possibility-date" @click="selectDate(firstPossibleDay.index)">{{ firstPossibleDay.day | moment('dddd D MMMM') }}</span>
              </p>

              <div id="timeslots">
                <div v-if="selectedDate " :class="{'possibilities-wrapper' : dateview == 'month'}">
                  <p class="selected-date">
                    <strong>{{ $t('possibilitiesSelectedDay') }} {{ selectedDate | moment('dddd D MMMM')}}</strong>
                  </p>
                
                  <div v-if="timeslots" class="timeslots-wrapper" :style="{'width': timesFitWidth + 'px'}">
                    <div v-if="!selectedTreatment.eventBooking">
                      <a v-for="(time, index) in timeslots" :key="index" class="time-item" @click="timeSelect(time, )">{{ time.timeStart }}</a>
                    </div>
                    <div v-if="selectedTreatment.eventBooking">
                      <v-container grid-list-md class="pa-1 ma-0">
                        <v-layout row wrap class="ma-0 pa-0" d-flex>
                          <v-flex sm6 xs12 v-for="(event, index) in timeslots" :key="index" >

                            <v-card class="event-card-wrapper" min-height="100%">
                              <v-card-text class="pa-2">
                                <p><strong>{{ event.startTime }} - {{ event.endTime }}u</strong></p>

                                <div class="show-seats">
                                  <v-chip :ripple="false"  disabled v-if="event.availableSeats == 0" small color="#f6f7fb" class="ma-0">
                                    {{ $t('noAvailability') }}
                                  </v-chip>
                                  <v-chip v-else :color="primaryColor" small class="ma-0" outlined>
                                    <div v-if="(event.availableSeats == 1)"><strong>{{ event.availableSeats }} {{ $t('availabilityOne') }}</strong></div>
                                    <div v-else><strong>{{ event.availableSeats }}  {{ $t('availabilityMore') }}</strong></div>
                                  </v-chip>
                                </div>
                              </v-card-text>

                              <v-card-actions class="pa-2" >
                                {{ event.availableSeats }}
                                <v-btn
                                  v-if="event.availableSeats > 0"
                                  depressed
                                  block
                                  color="#f6f7fb"
                                  @click="selectEventBooking(event)"
                                  >
                                  {{ $t('subscribe') }}
                                  <v-icon
                                    right
                                    dark
                                  >
                                    mdi-chevron-right
                                  </v-icon>
                                </v-btn>
                              </v-card-actions>
                            </v-card>

                          </v-flex>
                        </v-layout>
                      </v-container>

                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div v-else class="event-availability-wrapper">
            <div class="event-availability-heading">
              <div v-if="selectedTreatment.eventData.title ">
                <h2>{{ selectedTreatment.eventData.title }}</h2>
                <p class="ma-0">{{ selectedTreatment.eventData.description }}</p>
              </div>
              <div v-else>
                <h2>{{ selectedTreatment.eventData.treatmentTitle }}</h2>
                <p class="ma-0">{{ selectedTreatment.eventData.treatmentShortDesc }}</p>
              </div>
            </div>

            <div class="event-availability-events">
              <v-container grid-list-md class="pa-1 ma-0">
                <v-layout row wrap class="ma-0 pa-0" d-flex>
                  <v-flex sm6 xs12 v-for="(event, index) in selectedTreatment.eventData.events" :key="index">

                    <v-card class="event-card-wrapper" min-height="100%">
                      <v-card-text class="pa-2">
                        <h3><span class="day">{{ event.startFormatted | moment("dddd") }}</span> {{ event.startFormatted | moment("D MMMM") }}</h3>
                        <p>{{ event.startFormatted | moment("H:mm") }} - {{ event.end | moment("H:mm") }}u</p>

                        <div class="show-seats" v-if="checkBookingAvailabilityEvent(event).available && event.showSeats">
                          <v-chip :ripple="false"  disabled v-if="!checkAvailabilityEvent(event)" small color="#f6f7fb" class="ma-0">
                            {{ $t('noAvailability') }}
                          </v-chip>
                          <v-chip v-else :color="primaryColor" small class="ma-0" outlined>
                            <div v-if="(event.maxPersons - event.registrations.length) == 1"><strong>{{ event.maxPersons - event.registrations.length }} {{ $t('availabilityOne') }}</strong></div>
                            <div v-else><strong>{{ event.maxPersons - event.registrations.length }}  {{ $t('availabilityMore') }}</strong></div>
                          </v-chip>
                        </div>

                        <v-alert
                          v-if="!checkBookingAvailabilityEvent(event).available"
                          class="pa-1 pl-3 mt-1"
                          dense
                          text
                          :icon="false"
                          border="left"
                          :color="primaryColor" 
                          >
                          <span style="font-size: 14px" v-if="checkBookingAvailabilityEvent(event).reason == 'minLimit'">{{ $t('minLimitAlertStart') }}{{ event.minTimeLimitSubscription }}  {{ $t('minLimitAlertEnd') }}</span>
                          <span style="font-size: 14px" v-else>{{ $t('maxLimitAlertStart') }}{{ event.minTimeLimitSubscription }}  {{ $t('maxLimitAlertEnd') }}</span>
                        </v-alert>

                      </v-card-text>


                      <v-card-actions v-if="checkBookingAvailabilityEvent(event).available && checkAvailabilityEvent(event)" class="pa-2">
                        <v-btn
                          depressed
                          block
                          color="#f6f7fb"
                          @click="selectEvent(event)"
                          >
                          {{ $t('subscribe') }}
                          <v-icon
                            right
                            dark
                          >
                            mdi-chevron-right
                          </v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-card>

                  </v-flex>
                </v-layout>
              </v-container>

            </div>
          </div>

        </div>

        <div class="step-4" v-if="step == 4">
          <div class="py-6 px-3 text-center" style="background-color: #f6f7fb" >
            <h4><strong><span style="text-transform: capitalize">{{ selectedDate | moment('dddd')}}</span> {{ selectedDate | moment('D MMMM YYYY')}}</strong> {{ $t('at') }}  <strong>{{ selectedTime.timeStart}}u</strong></h4>
          </div>
          
          <div class="treatment-summary" v-if="selectedTreatment.treatments.length > 0">
            <div class="pt-5 pb-2 px-2 text-center">
              <div v-if="selectedTreatment.eventBooking">
                 <h3><strong>{{ $t('chosenEventBooking') }}</strong></h3>
              </div>
              <div v-else>
                <h3 v-if="selectedTreatment.treatments.length > 1"><strong>{{ $t('chosenTreatments') }}</strong></h3>
                <h3 v-else><strong>{{ $t('chosenTreatment') }}</strong></h3>
              </div>
            </div>

            <v-card class="ma-3 mb-5" outlined style="background-color: rgba(240,241,245, 0.5); box-shadow: 0 1px 5px rgba(193,201,215, 0.5);">
              <v-list-item class="treatment-summary-wrapper" two-line v-for="(treatment, index) in selectedTreatment.treatmentsData" :key="index">
                <v-list-item-content>
                  <v-list-item-title style="color:#0d1f31;">{{ treatment.treatmentTitle }}</v-list-item-title>
                  <v-list-item-subtitle style="color:#0d1f31;">{{ treatment.treatmentShortDesc }}</v-list-item-subtitle>
                  
                </v-list-item-content>
                <v-list-item-action-text v-if="showPrices">
                  <span class="treatment-price summary" v-if="treatment.treatmentPrice">
                    {{ numberWithCommas(treatment.treatmentPrice) }}
                  </span>
                  <span class="treatment-price empty"  v-else>-</span>
                </v-list-item-action-text>
              </v-list-item>
              <v-list-item v-if="showPrices">
                <v-list-item-content>
                  <v-list-item-title><strong>{{ $t('priceTotal') }}</strong></v-list-item-title>
                </v-list-item-content>
                <v-list-item-action-text >
                  <span class="treatment-price summary total">{{ numberWithCommas(totalTreatmentPrice) }}</span>
                </v-list-item-action-text>
              </v-list-item>
            </v-card>
          </div>

          <div class="event-summary" v-if="selectedEvent">
            <div class="pt-5 pb-2 px-2 text-center">
              <h3><strong>{{ $t('chosenEvent') }}</strong></h3>
            </div>

            <v-card class="ma-3 mb-5" outlined style="background-color: rgba(240,241,245, 0.5); box-shadow: 0 1px 5px rgba(193,201,215, 0.5);">
              <v-list-item class="treatment-summary-wrapper" two-line>
                <v-list-item-content>
                  <v-list-item-title v-if="selectedEvent.treatmentTitle" style="color:#0d1f31;">{{ selectedEvent.treatmentTitle }}</v-list-item-title>
                  <v-list-item-title v-else style="color:#0d1f31;">{{ selectedEvent.title }}</v-list-item-title>
                  <v-list-item-subtitle v-if="selectedEvent.treatmentShortDesc " style="color:#0d1f31;"><strong>{{ selectedEvent.treatmentShortDesc }}</strong></v-list-item-subtitle>
                  <v-list-item-subtitle v-else style="color:#0d1f31;">{{ selectedEvent.description }}</v-list-item-subtitle>
                  <v-list-item-subtitle v-if="eventDuration(selectedEvent)" style="color:#0d1f31;">{{ eventDuration(selectedEvent) }} {{ $t('minutes') }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </div>

          <!-- <div v-if="downPaymentAmount > 0">
            aanbetaling vereist
          </div>

          <div v-else>
            GEEN aanbetaling vereist
          </div> -->

          <!-- <v-checkbox 
            v-model="confirmEmail"
            required
            class="ma-0 pa-0 px-3"
            :label="$t('sendConfirmationEmail')"
            >
          </v-checkbox> -->

          <div class="py-5 px-3 text-center" style="padding-bottom: 90px!important;">
            <p class="pt-4 company-info">
              <span class="company-name"><strong>{{this.compdata.name}}</strong></span> <span class="company-branch-name"><strong>{{this.selectedBranchData.name}}</strong></span><br>
              {{this.selectedBranchData.branchAddress.address}} {{this.selectedBranchData.branchAddress.nr}}<br>
              {{this.selectedBranchData.branchAddress.postalCode}} {{this.selectedBranchData.branchAddress.city}}
            </p>
          </div>

        </div>

        <div class="step-5" v-if="step == 5">
          <div class="py-6 mb-3 px-3 text-center" style="background-color: #f6f7fb" >
            <h2 class="pb-1">{{ $t('appointmentScheduled') }} </h2>
            <p class="ma-0">{{ $t('lookingForwardToYourVisit') }}</p>
          </div>
          <div class="my-6 pt-6 px-6 text-center">
            <v-avatar color="#f6f7fb" size="160">
              <v-icon color="primary" size="70">mdi-thumb-up</v-icon>
            </v-avatar>
          </div>
          <div class="pt-0 px-3 text-center" >
       
            <p class="pt-4 company-info">
              <span class="company-name"><strong>{{this.compdata.name}}</strong></span> <span class="company-branch-name"><strong>{{this.selectedBranchData.name}}</strong></span><br>
              {{this.selectedBranchData.branchAddress.address}} {{this.selectedBranchData.branchAddress.nr}}<br>
              {{this.selectedBranchData.branchAddress.postalCode}} {{this.selectedBranchData.branchAddress.city}}
            </p>
            <p class="confirm-email-text">{{ $t('confirmationMail') }} <strong>{{ this.email }}</strong>.</p>
          </div>
        </div>

        <div class="step-7" v-if="step == 7">
          <div v-if="!cancelBookingLoading">

            <div v-if="cancelBookingStatus == 'bookingAccepted' || cancelBookingStatus == 'eventAccepted'">
              <div class="py-6 mb-3 px-3 text-center" style="background-color: #f6f7fb" >
                <h2 class="pb-1">{{ cancelBookingData.treatmentTitle }} {{ cancelBookingData.title }} </h2>
                <p class="ma-0">{{ cancelBookingData.start | moment("D MMMM YYYY H:mm") }} - {{ cancelBookingData.end | moment("H:mm") }}u</p>
              </div>
              <div  class="py-2 mb-3 px-3 text-center">
                <p v-if="cancelBookingData.type == 'eventbooking'"><strong>{{ $t('cancelEventReason') }}</strong></p>
                <p v-else><strong>{{ $t('cancelBookingReason') }}</strong></p>
                <v-radio-group v-model="cancelBookingReason">
                  <v-radio
                    :label="$t('cancelBookingReasonTime')"
                    value="timeInconvenience"
                  ></v-radio>
                  <v-radio
                    :label="$t('cancelBooking')"
                    value="cancelBooking"
                  ></v-radio>
                  <v-radio
                    :label="$t('cancelBookingReasonOther')"
                     value="other"
                  ></v-radio>
                </v-radio-group>

                <v-textarea
                  :label="$t('cancelBookingReasonOtherLabel')"
                  v-if="cancelBookingReason != 'timeInconvenience' && cancelBookingReason != 'cancelBooking' "
                  outlined
                  v-model="cancelBookingReasonOther"
                  :placeholder="$t('cancelBookingReasonOtherLabelPlaceholder')"
                  :rows="3"
                  background-color="background"
                ></v-textarea>

                <v-btn
                  v-if="cancelBookingData.type == 'eventbooking'"
                  class="mt-3"
                  dark
                  color="secondary"
                  @click="unsubscribeEvent()"
                  >
                  {{ $t('eventUnsubscribe') }}
                </v-btn>

                <v-btn
                  v-else
                  class="mt-3"
                  dark
                  color="secondary"
                  @click="cancelBooking()"
                  >
                  {{ $t('cancelBooking') }}
                </v-btn>
              </div>
            </div>

            <div v-else>
              <div class="py-6 mb-3 px-3 text-center" style="background-color: #f6f7fb" >
                <h3 v-if="cancelBookingStatus == 'bookingCanceled'"  class="pb-1">{{ $t('bookingCanceled') }}</h3>
                <h3 v-if="cancelBookingStatus == 'bookingInHistory'" class="pb-1">{{ $t('bookingInHistory') }}</h3>
                <h3 v-if="cancelBookingStatus == 'bookingTooClose'" class="pb-1">{{ $t('bookingTooCloseOne') }} {{this.compdata.calendarSettings.cancelTimeLimit }} {{ $t('bookingTooCloseTwo') }}</h3>
                <h3 v-if="cancelBookingStatus == 'bookingError'" class="pb-1">{{ $t('bookingError') }}</h3>
                <h3 v-if="cancelBookingStatus == 'eventNoClientId'" class="pb-1">{{ $t('eventNoClientId') }}</h3>
                <h3 v-if="cancelBookingStatus == 'eventClientIdNotRegistered'" class="pb-1">{{ $t('eventClientIdNotRegistered') }}</h3>
                <p v-if="cancelBookingStatus == 'eventClientIdNotRegistered'" class="ma-0"> {{ $t('eventClientIdNotRegisteredExtra') }}</p>
              </div>

              <div class="my-6 pt-6 px-6 text-center">
                <v-avatar color="#f6f7fb" size="160">
                  <v-icon color="secondary" size="70">mdi-alert-octagon</v-icon>
                </v-avatar>
              </div>


              <div class="py-2 mb-3 px-3 text-center">
                <v-btn
                  class="mt-3"
                  dark
                  color="primary"
                  @click="resetWidgetData()"
                  >
                  {{ $t('newAppointment') }}
                </v-btn>
              </div>
            </div>

          </div>

           <div v-else class="text-center" style="padding: 50px 10px 10px 10px;">
            <v-progress-circular
              :size="50"
              :color="secondaryColor"
              indeterminate
            ></v-progress-circular>
          </div>
        </div>

        <div class="step-8" v-if="step == 8">
          <div class="py-6 mb-3 px-3 text-center" style="background-color: #f6f7fb" >
            <h2 v-if="cancelBookingData.type == 'eventbooking'" class="pb-1">{{ $t('cancelEventSuccess') }} </h2>
            <h2 v-else class="pb-1">{{ $t('cancelBookingSuccess') }} </h2>
            <p class="ma-0">{{ $t('lookingForwardToSeeYouAgain') }}</p>
          </div>
          <div class="my-6 pt-6 px-6 text-center">
            <v-avatar color="#f6f7fb" size="160">
              <v-icon color="primary" size="70">mdi-thumb-up</v-icon>
            </v-avatar>
          </div>
          <div class="pt-0 px-3 text-center" >
            <v-btn
              class="mt-3"
              dark
              color="secondary"
              @click="resetWidgetData()"
              >
              {{ $t('newAppointment') }}
            </v-btn>
          </div>
          
        </div>

        <div class="step-9" v-if="step == 9">

          <div v-if="leadsLoading" class="text-center" style="padding: 50px 10px 10px 10px;">
            <v-progress-circular
              :size="50"
              :color="secondaryColor"
              indeterminate
            ></v-progress-circular>
          </div>
          <div v-else style="padding: 0 0 90px 0">
            <v-alert v-if="leadInfo.feedback.message" class="ma-0 pa-2" style="border-radius: 0" text outlined :icon="leadInfo.feedback.icon" :type="leadInfo.feedback.type">{{ leadInfo.feedback.message }}</v-alert>

            <div v-if="leadCampaignData.formIntro && leadCampaignData.formIntro[language.toLowerCase()]" class="py-4 mb-3 px-3 text-center" style="background-color: #f6f7fb" >
              <p class="ma-0">{{ leadCampaignData.formIntro[language.toLowerCase()]}}</p>
            </div>
            
            <div class="my-0 pt-1 px-4 text-center">
              <v-form ref="clientInformationForm" v-model="leadInformationValid">
                <v-container grid-list-md  class="pa-0 ma-0">
                  <v-layout row wrap class="ma-0 pa-0">
                    <v-flex xs6>
                      <v-text-field
                        outlined
                        v-model="leadInfo.firstName"
                        :counter="30"
                        :rules="nameRules"
                        :label="$t('firstName')"
                        required
                        class="mt-2"
                        hide-details
                        background-color="background"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        outlined
                        v-model="leadInfo.lastName"
                        :counter="30"
                        :rules="nameRules"
                        :label="$t('lastName')"
                        required
                        class="mt-2"
                        hide-details
                        background-color="background"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        outlined
                        v-model="leadInfo.email"
                        :rules="emailRules"
                        label="E-mail"
                        required
                        hide-details
                        background-color="background"
                      ></v-text-field>
                    </v-flex>
                    <v-flex sm5 xs12 class="pb-0">
                      <v-select
                        outlined
                        hide-details
                        class="pa-0 ma-0 phone-lang-select"
                        content-class="pa-0 ma-0"
                        :items="languages"
                        v-model="leadInfo.selectedPhoneLanguage"
                        background-color="background"
                        item-text="item"
                        item-value="phone"
                        >
                        <template slot="selection" slot-scope="data" class="ma-0 pa-0">
                          <country-flag :country="data.item.id" />
                          <span>{{ data.item.phone }}</span>
                        </template>
                        <template slot="item" slot-scope="data">
                          <country-flag :country="data.item.id" />
                          <span >{{ data.item.phone }}</span>
                        </template>
                      </v-select>
                    </v-flex>
                    <v-flex sm7 xs12 class="pb-0">
                      <v-text-field
                        class="ma-0 pa-0"
                        outlined
                        v-model="leadInfo.tel"
                        :counter="9"
                        :rules="telRules"
                        :label="$t('telephone')"
                        required
                        background-color="background"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 v-if="leadInfo.questions.length > 0">
                      <div v-for="(question, index) in leadInfo.questions" :key="index">
                        <v-container v-if="question.type == 'yesNo'" class="pa-0 ma-0" fill-height fluid>
                          <v-row align="center" justify="center">
                            <v-col cols="8" class="text-left">
                              {{ question[language.toLowerCase()] }}
                            </v-col>
                            <v-col cols="4" class="text-right">
                              <v-btn-toggle v-model="question.value" color="primary">
                                <v-btn small value="yes">
                                  {{ language.toLowerCase() == 'en' ? "Yes" : "Ja"  }}
                                </v-btn>
                                <v-btn small value="no">
                                  {{ language.toLowerCase() == 'en' ? "No" : "Nee"  }}
                                </v-btn>
                              </v-btn-toggle>
                            </v-col>
                          </v-row>
                        </v-container>

                        <div v-if="question.type == 'open'" class="text-left">
                          <v-textarea
                            :label="question[language.toLowerCase()]"
                            v-model="question.value"
                            background-color="background"
                            outlined
                            rows="2"
                            hide-details
                          ></v-textarea>
                        </div>
                      </div>

                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>

            </div>
          </div>
        </div>

        <div class="step-10" v-if="step == 10">
          <div class="py-6 mb-3 px-3 text-center" style="background-color: #f6f7fb" >
            <h2 class="pb-1">{{ $t('leadSuccessMessageTitel') }}</h2>
            <p class="ma-0">{{ $t('leadSuccessMessage') }}</p>
          </div>
          <div class="my-6 pt-6 px-6 text-center">
            <v-avatar color="#f6f7fb" size="160">
              <v-icon color="primary" size="70">mdi-thumb-up</v-icon>
            </v-avatar>
          </div>
          
        </div>

      </div>

      <div v-else class="text-center pa-4">
        <v-icon v-if="error.icon == 'info'" class="pa-4 ma-4" color="primary" x-large>mdi-information-outline</v-icon>
        <v-icon v-else class="pa-4 ma-4" color="warning" x-large>mdi-alert</v-icon>
        <p>{{ error.message }}</p>
      </div>
    </div>

    <div class="widget-footer" v-if="widgetSettings.active && (step == 0 || step == 2 || step == 4 || step == 9)" :class="{'hide' : noTreatmentsSelected }">
      <v-container grid-list-md fluid class="ma-0 pa-0" v-if="step == 0 || step == 2">
        <v-layout v-if="step == 2" row wrap class="ma-0 pa-0">
          <v-flex xs6 class="text-left">
            <div class="selected-treatments-label pa-2 pt-1 pb-0" v-if="step == 2 && selectedTreatment.treatments.length == 1"> 1 {{ $t('treatmentSelected') }}</div>
            <div class="selected-treatments-label pa-2 pt-1 pb-0" v-if="step == 2 && selectedTreatment.treatments.length > 1"> {{ selectedTreatment.treatments.length}} {{ $t('treatmentsSelected') }}</div>
            <div class="selected-treatments-label pa-2 pt-1 pb-0" v-if="step == 2 && selectedTreatment.event">1 {{ $t('eventSelected') }}</div>
            <div class="total-price-wrapper pa-2 pt-0" style="font-size: 14px;" v-if="step == 2 && this.showPrices  && selectedTreatment.treatments.length > 0">
              <div class="total-label">{{ $t('priceTotal') }}: </div>
              <div id="total-price" class="pricing-footer">{{ numberWithCommas(totalTreatmentPrice) }}</div>
            </div>
          </v-flex>
          <v-flex xs6 class="text-right">
            <v-btn
              class="mt-3"
              rounded
              :dark="valid"
              :depressed="!valid"
              :disabled="!valid"
              :color="secondaryColor"
              @click="next()"
              >
              {{ $t('basicdictionary.next') }}
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout v-else row wrap class="ma-0 pa-0">
          <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'"></v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              class="mt-3"
              rounded
              :dark="valid"
              :depressed="!valid"
              :disabled="!valid"
              :loading="clientCacheLoading"
              :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
              :color="secondaryColor"
              @click="next()"
              >
              {{ $t('basicdictionary.next') }}
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container grid-list-md fluid class="ma-0 pa-0" v-if="step == 4">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex xs12>
             <v-btn
              v-if="selectedTreatment.eventBooking"
              rounded
              block
              large
              dark
              :loading="posting"
              style="text-transform: uppercase"
              class="mt-3"
              :color="secondaryColor"
              @click="confirmEventBooking()"
              >
              <strong>{{ $t('basicdictionary.confirmEventBooking') }}</strong>
            </v-btn>
            <div v-else>
                <v-btn
                v-if="downPaymentRequired"
                rounded
                block
                large
                dark
                :loading="posting"
                style="text-transform: uppercase"
                class="mt-3"
                :color="secondaryColor"
                @click="confirmBooking()"
                >
                <strong>{{ $t('basicdictionary.confirmWithDownPayment') }}</strong>
              </v-btn>
              <v-btn
                v-else
                rounded
                block
                large
                dark
                :loading="posting"
                style="text-transform: uppercase"
                class="mt-3"
                :color="secondaryColor"
                @click="confirmBooking()"
                >
                <strong>{{ $t('basicdictionary.confirm') }}</strong>
              </v-btn>

            
            </div>

            
           
          </v-flex>
        </v-layout>
      </v-container>

      <v-container grid-list-md fluid class="ma-0 pa-0" v-if="step == 9">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex xs12>
            <v-btn
              rounded
              block
              large
              dark
              :loading="leadFormPosting"
              style="text-transform: uppercase"
              class="mt-3"
              :color="secondaryColor"
              @click="sendLeadInfo()"
              >
              <strong>{{ $t('sendLeadInfo') }}</strong>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </div>

  </v-card>
</template>


<script>
import db from "../firebase/init";
import { bus } from "../main";
import _ from "lodash";
import moment from "moment";
import axios from "axios";
import CountryFlag from "vue-country-flag";


export default {
  name: "widget",
  props: {
    showType: String,
    language: String,
    widgetHeight: String,
    widgetContentHeight: Number,
    company: String,
    showPrices: Boolean,
    preSelectedBranch: String,
    preSelectedTreatment: String,
    bookingId: String,
    seperateTreatments: false,
    primaryColor: String,
    secondaryColor: String,
    source: String,
    startUrl: String,
    executedFrom: String,
    userAgent: String,
    actionType: String,
    clientIdBooking: String,
    multiTreatmentBooking: Boolean,
    leadFormId: String
  },
  components: { CountryFlag },
  data() {
    return {
      apiUrl: "https://api.thrive365.nl", // "http://localhost:3000 bij develop", 
      todayFormatted: null,
      today: moment().format("YYYY-MM-DD"),
      // Loading & Errors
      cacheToken: null,
      clientCacheLoading: false,
      
      loadingCompData: false, 
      widgetSettings: {
        active: true,
        notification: {
          message: {},
          messageTitle: {}
        }
      },
      loadingTreatments: true,
      employeesLoading: false,
      error: {
        active: false,
        type: null,
        message: null,
        icon: 'warning'
      },
      docId: null,
      // Personal Data
      firstName: "",
      lastName: "",
      nameRules: [
        v => !!v || this.$t('nameRequired'),
        v => (v && v.length <= 30) || this.$t('nameLength') 
      ],
      email: "",
      emailRules: [
        v => !!v || this.$t('emailRequired'),
        v => /^\w+([\.-]?\w+)+@\w+([\.:]?\w+)+(\.[a-zA-Z0-9]{2,3})+$/.test(v) || this.$t('emailValid')
      ],
      tel: "",
      telTemp: "",
      telRules: [
        v => !!v || this.$t('phoneRequired'),
        v => (v && v.length > 8) || this.$t('phoneLength'),
        v => /^[0-9+]*$/.test(v) || this.$t('phoneValid')
      ],
      ip: {
        query: null
      },
      existingClient: true,
      clientId: "",
      apiError: null,

      checkRules: [v => !!v || this.$t('acceptTerms')],
      terms: false,
      showTerms: false,
      saveClientInformation: false,
      clientInformationValid: false, 
      bookingTerms: {
        nl: "Hogans, gevestigd aan Parijsboulevard 209, 3541 CS UTRECHT, is verantwoordelijk voor de verwerking van deze persoonsgegevens zoals weergegeven in deze privacyverklaring. Contactgegevens: https://www.hogans-agency.nl Parijsboulevard 209, 3541 CS UTRECHT +31 (0) 85 020 74 22 De Functionaris Gegevensbescherming van Hogans is bereikbaar via info@hogans.nl Persoonsgegevens die wij verwerken Hogans verwerkt uw persoonsgegevens doordat u gebruik maakt van onze diensten en/of omdat u deze zelf aan ons verstrekt. Hieronder vindt u een overzicht van de persoonsgegevens die wij verwerken: - Voor- en achternaam - Geslacht - Telefoonnummer - E-mailadres - IP-adres - Locatiegegevens - Internetbrowser en apparaat type Bijzondere en/of gevoelige persoonsgegevens die wij verwerken Deze applicatie heeft niet de intentie gegevens te verzamelen over websitebezoekers die jonger zijn dan 16 jaar. Tenzij ze toestemming hebben van ouders of voogd. We kunnen echter niet controleren of een bezoeker ouder dan 16 is. Wij raden ouders dan ook aan betrokken te zijn bij de online activiteiten van hun kinderen, om zo te voorkomen dat er gegevens over kinderen verzameld worden zonder ouderlijke toestemming. Als u er van overtuigd bent dat wij zonder die toestemming persoonlijke gegevens hebben verzameld over een minderjarige, neem dan contact met ons op via info@hogans.nl, dan verwijderen wij deze informatie. Met welk doel en op basis van welke grondslag wij persoonsgegevens verwerken Hogans verwerkt uw persoonsgegevens voor de volgende doelen: U te kunnen bellen of e-mailen indien dit nodig is om de dienstverlening van onze klanten (beter) uit te kunnen voeren Hogans AgencyHogans Agency Digitale successen met Hogans Agency Digitale oplossingen voor elk platform. Kennis van zaken en passie voor ons werk. Dat is Hogans Agency.(1 kB) https://e7h3v8y3.stackpathcdn.com/wp-content/uploads/2020/01/hogans-voip-1.png 11:07 - U te informeren over wijzigingen van diensten en producten van onze klanten - U de mogelijkheid te bieden een account aan te maken - Hogans analyseert uw gedrag op de website om daarmee de website te verbeteren en het aanbod van producten en diensten af te stemmen op uw voorkeuren.  Hoe lang we persoonsgegevens bewaren Hogans bewaart uw persoonsgegevens niet langer dan strikt nodig is om de doelen te realiseren waarvoor uw gegevens worden verzameld. Wij hanteren de volgende bewaartermijnen voor de volgende (categorieën) van persoonsgegevens: Persoonsgegevens > 2 jaar > mogelijkheid tot analyse en verbetering dienstverlening              Delen van persoonsgegevens met derden Hogans verstrekt uitsluitend aan derden en alleen als dit nodig is voor de uitvoering van onze overeenkomst met u of om te voldoen aan een wettelijke verplichting.  Cookies, of vergelijkbare technieken, die wij gebruiken Hogans gebruikt geen cookies of vergelijkbare technieken. Gegevens inzien, aanpassen of verwijderen  U heeft het recht om uw persoonsgegevens in te zien, te corrigeren of te verwijderen. Daarnaast heeft u het recht om uw eventuele toestemming voor de gegevensverwerking in te trekken of bezwaar te maken tegen de verwerking van uw persoonsgegevens door Hogans en heeft u het recht op gegevensoverdraagbaarheid. Dat betekent dat u bij ons een verzoek kunt indienen om de persoonsgegevens die wij van u beschikken in een computerbestand naar u of een ander, door u genoemde organisatie, te sturen. U kunt een verzoek tot inzage, correctie, verwijdering, gegevensoverdraging van uw persoonsgegevens of verzoek tot intrekking van uw toestemming of bezwaar op de verwerking van uw persoonsgegevens sturen naar info@hogans.nl. Om er zeker van te zijn dat het verzoek tot inzage door u is gedaan, vragen wij u een kopie van uw identiteitsbewijs met het verzoek mee te sturen. Maak in deze kopie uw pasfoto, MRZ (machine readable zone, de strook met nummers onderaan het paspoort), paspoortnummer en Burgerservicenummer (BSN) zwart. Dit ter bescherming van uw privacy. We reageren zo snel mogelijk, maar binnen vier weken, op uw verzoek. Hogans wil u er tevens op wijzen dat u de mogelijkheid heeft om een klacht in te dienen bij de nationale toezichthouder, de Autoriteit Persoonsgegevens. Dat kan via de volgende link: https://autoriteitpersoonsgegevens.nl/nl/contact-met-de-autoriteit-persoonsgegevens/tip-ons Hoe wij persoonsgegevens beveiligen Hogans neemt de bescherming van uw gegevens serieus en neemt passende maatregelen om misbruik, verlies, onbevoegde toegang, ongewenste openbaarmaking en ongeoorloofde wijziging tegen te gaan. Als u de indruk heeft dat uw gegevens niet goed beveiligd zijn of er aanwijzingen zijn van misbruik, neem dan contact op met onze klantenservice of via info@hogans.nl",
        en: "Hogans, gevestigd aan Parijsboulevard 209, 3541 CS UTRECHT, is verantwoordelijk voor de verwerking van deze persoonsgegevens zoals weergegeven in deze privacyverklaring. Contactgegevens: https://www.hogans-agency.nl Parijsboulevard 209, 3541 CS UTRECHT +31 (0) 85 020 74 22 De Functionaris Gegevensbescherming van Hogans is bereikbaar via info@hogans.nl Persoonsgegevens die wij verwerken Hogans verwerkt uw persoonsgegevens doordat u gebruik maakt van onze diensten en/of omdat u deze zelf aan ons verstrekt. Hieronder vindt u een overzicht van de persoonsgegevens die wij verwerken: - Voor- en achternaam - Geslacht - Telefoonnummer - E-mailadres - IP-adres - Locatiegegevens - Internetbrowser en apparaat type Bijzondere en/of gevoelige persoonsgegevens die wij verwerken Deze applicatie heeft niet de intentie gegevens te verzamelen over websitebezoekers die jonger zijn dan 16 jaar. Tenzij ze toestemming hebben van ouders of voogd. We kunnen echter niet controleren of een bezoeker ouder dan 16 is. Wij raden ouders dan ook aan betrokken te zijn bij de online activiteiten van hun kinderen, om zo te voorkomen dat er gegevens over kinderen verzameld worden zonder ouderlijke toestemming. Als u er van overtuigd bent dat wij zonder die toestemming persoonlijke gegevens hebben verzameld over een minderjarige, neem dan contact met ons op via info@hogans.nl, dan verwijderen wij deze informatie. Met welk doel en op basis van welke grondslag wij persoonsgegevens verwerken Hogans verwerkt uw persoonsgegevens voor de volgende doelen: U te kunnen bellen of e-mailen indien dit nodig is om de dienstverlening van onze klanten (beter) uit te kunnen voeren Hogans AgencyHogans Agency Digitale successen met Hogans Agency Digitale oplossingen voor elk platform. Kennis van zaken en passie voor ons werk. Dat is Hogans Agency.(1 kB) https://e7h3v8y3.stackpathcdn.com/wp-content/uploads/2020/01/hogans-voip-1.png 11:07 - U te informeren over wijzigingen van diensten en producten van onze klanten - U de mogelijkheid te bieden een account aan te maken - Hogans analyseert uw gedrag op de website om daarmee de website te verbeteren en het aanbod van producten en diensten af te stemmen op uw voorkeuren.  Hoe lang we persoonsgegevens bewaren Hogans bewaart uw persoonsgegevens niet langer dan strikt nodig is om de doelen te realiseren waarvoor uw gegevens worden verzameld. Wij hanteren de volgende bewaartermijnen voor de volgende (categorieën) van persoonsgegevens: Persoonsgegevens > 2 jaar > mogelijkheid tot analyse en verbetering dienstverlening              Delen van persoonsgegevens met derden Hogans verstrekt uitsluitend aan derden en alleen als dit nodig is voor de uitvoering van onze overeenkomst met u of om te voldoen aan een wettelijke verplichting.  Cookies, of vergelijkbare technieken, die wij gebruiken Hogans gebruikt geen cookies of vergelijkbare technieken. Gegevens inzien, aanpassen of verwijderen  U heeft het recht om uw persoonsgegevens in te zien, te corrigeren of te verwijderen. Daarnaast heeft u het recht om uw eventuele toestemming voor de gegevensverwerking in te trekken of bezwaar te maken tegen de verwerking van uw persoonsgegevens door Hogans en heeft u het recht op gegevensoverdraagbaarheid. Dat betekent dat u bij ons een verzoek kunt indienen om de persoonsgegevens die wij van u beschikken in een computerbestand naar u of een ander, door u genoemde organisatie, te sturen. U kunt een verzoek tot inzage, correctie, verwijdering, gegevensoverdraging van uw persoonsgegevens of verzoek tot intrekking van uw toestemming of bezwaar op de verwerking van uw persoonsgegevens sturen naar info@hogans.nl. Om er zeker van te zijn dat het verzoek tot inzage door u is gedaan, vragen wij u een kopie van uw identiteitsbewijs met het verzoek mee te sturen. Maak in deze kopie uw pasfoto, MRZ (machine readable zone, de strook met nummers onderaan het paspoort), paspoortnummer en Burgerservicenummer (BSN) zwart. Dit ter bescherming van uw privacy. We reageren zo snel mogelijk, maar binnen vier weken, op uw verzoek. Hogans wil u er tevens op wijzen dat u de mogelijkheid heeft om een klacht in te dienen bij de nationale toezichthouder, de Autoriteit Persoonsgegevens. Dat kan via de volgende link: https://autoriteitpersoonsgegevens.nl/nl/contact-met-de-autoriteit-persoonsgegevens/tip-ons Hoe wij persoonsgegevens beveiligen Hogans neemt de bescherming van uw gegevens serieus en neemt passende maatregelen om misbruik, verlies, onbevoegde toegang, ongewenste openbaarmaking en ongeoorloofde wijziging tegen te gaan. Als u de indruk heeft dat uw gegevens niet goed beveiligd zijn of er aanwijzingen zijn van misbruik, neem dan contact op met onze klantenservice of via info@hogans.nl"
      },
      // Company
      compdata: null,
      // Branches
      selectedBranch:null,
      selectedBranchData: null,
      branches: [],

      // Treatments & Events
      treatmentsLoading: false,
      
      treatmentsGender: {
        female: 0,
        male: 0,
      },
      selectedGender: 'all',
      treatmentSearch: "",
      treatments: [],
      treatmentSelected: false,
      treatmentTypes: [],
      events: [],
      treatmentIndex: 0,
      selectedTreatment: {
        type: null,
        treatments: [],
        treatmentsData: [],
        event: null,
        eventData: null,
        noEmployeeSubtreatment: false,
        eventBooking: null,
        eventBookingData: null
      }, 
      totalTreatmentPrice: 0,
      dateWidth: 63,
      datesFitWidth: 0,
      timesFitWidth: 0,
      nextStepEnabled: false,
      // Employees
      employees :[
        {
          id: 0,
          name:  this.$t('noPreference')
        }
      ],
      leadInfo: {},
      leadsLoading: false,
      leadFormPosting: false,
      leadInformationValid: false,
      selectedEmployee: 0,
      selectedEmployeeData: {
        id: 0,
        name: 'Geen voorkeur'
      },
      leadCampaignData: {},
      
      dateview: 'month',
      currentDayOfMonth: null,
      activeMonth: null,

      // Availability
      availability: [],
      availabilityMonth: [],
      availabilityLoading: false,
      availabilityLoadingExtra: false,
      timeslots: [],
      selectedEvent: null,
      selectedEventBooking: null,
      selectedDate: null,
      selectedTime: null,
      selectedSector: null,
      firstPossibleDay: null,

      availabilityMargin: 0,

      feedback:{
        icon: 'mdi-alert',
        type: 'warning',
        message: null
      },
      selectedPhoneLanguage: {
        name: "Nederland",
        id: "nl",
        code: "NL",
        phone: "+31"
      },
      selectedLanguage: {
        name: "Nederland",
        id: "nl",
        code: "NL",
        phone: "+31"
      },

      showingMonthIsNotCurrentMonth: false,

      startFrom: 0,
      numberOfDays: 14,
      windowDates: 0,
      confirmEmail: true,
      preSelectedTreatmentData: null,
      cancelBookingData: null,
      cancelBookingStatus: null,
      cancelBookingLoading: false,
      cancelBookingReason: null,
      cancelBookingReasonOther: null,
      posting: false,
      downPaymentRequired: false,
      downPaymentAmount: 0,
      languages: [
        {
          name: "Nederland",
          id: "nl",
          code: "NL",
          phone: "+31"
        },
        {
          name: "English",
          id: "gb",
          code: "EN",
          phone: "+44"
        },
        {
          name: "Deutschland",
          id: "de",
          code: "DE",
          phone: "+49"
        },
        {
          name: "België",
          id: "be",
          code: "BE",
          phone: "+32"
        },
        {
          name: "France",
          id: "fr",
          code: "FR",
          phone: "+33"
        },
        {
          name: "United States",
          id: "us",
          code: "US",
          phone: "+1"
        },
        {
          name: "Canada",
          id: "can",
          code: "CAN",
          phone: "+44"
        },
        {
          name: "Rusland",
          id: "rus",
          code: "RUS",
          phone: "+7"
        }               
      ],
      step: 0,
      steps: [
        {
          name: {
            nl: "Persoonlijke gegevens",
            gb: "Personal information"
          }
        },
        {
          name: {
            nl: "Vestiging",
            gb: "Branch"
          }
        },
        {
          name: {
            nl: "Behandelingen",
            gb: "Treatments"
          }
        },
        {
          name: {
            nl: "Datum & Tijdstip",
            gb: "Date & Time"
          }
        },
        {
          name: {
            nl: "Bevestig afspraak",
            gb: "Confirm appointment"
          }
        },
        {
          name: {
            nl: "Afspraak gemaakt",
            gb: "Appointment made"
          }
        },
        {
          name: { // Wordt weergegeven als
            nl: "Niet beschikbaar",
            gb: "Not available"
          }
        },
        {
          name: { // Uitgeschrijven overzicht
            nl: "Afspraak annuleren",
            gb: "Cancel appointment"
          }
        },
        {
          name: { // Succesvol uitgeschreven
            nl: "Succesvol geannuleerd",
            gb: "Canceled successfully"
          }
        }, 
        {
          name: { // Leadform
            nl: "Ik ben geïnteresseerd",
            gb: "I am interested"
          }
        }, 
        {
          name: { // Leadform Succes
            nl: "Verzonden",
            gb: "Send"
          }
        }          
      ],
    };
  },

  created() {
    this.loadWidgetData();
    this.error.active = false;
    moment.locale((this.selectedLanguage.code).toLowerCase())
    this.todayFormatted = moment().format("ddd");
    // bus.$on('startWidget', this.loadWidgetData());
  },

  methods: {
    loadWidgetData(){
      this.cancelBookingData = null;
      this.cancelBookingStatus = null;
      this.loadingCompData = true;
      if(this.actionType == 'cancelBooking' && this.bookingId){
        this.cancelBookingLoading = true;
        // console.log("Widget start cancelBooking", this.actionType)
        this.getCompanyData();
        this.cancelBookingCheck()
      }
      else if(this.actionType == 'shortcut' && this.preSelectedTreatment){
        // console.log("Widget start Shortcut", this.actionType)
        this.checkLocalStorage();
        this.getCompanyData();
        this.getIp();
        this.getPreSelectedTreatment();
      }
      else if(this.actionType == 'leadForm' && this.leadFormId){
        // console.log("Widget start leadForm", this.actionType)
        this.getCompanyData();
        this.getLeadForm();
      }
      else{
        // console.log("Widget start Booking", this.actionType)
        this.checkLocalStorage();
        this.getCompanyData();
        this.getIp();
      }
    },

    getCompanyData(){
      if(this.company){
        db.collection("companies")
        .doc(this.company).get()
        .then(doc => {
          if (doc.exists) {
            this.compdata = doc.data();
            this.compdata.id = doc.id;
          }
          else{
            this.error.active = true;
            this.error.type = "settings"
            this.error.icon = "warning"
            this.error.message = this.$t('alert.widgetSettingsError');
            this.loadingCompData = false;
          }
        })
        .then(()=>{
          this.checkBranchesData();
        })
        .catch(error=>{
          console.error("Fout bij laden van bedrijf: ", error)
          this.error.active = true;
          this.error.type = "settings"
          this.error.icon = "warning"
          this.error.message = this.$t('alert.widgetCompanySettingsError');
          this.loadingCompData = false;
        })
      }
      else{
        this.error.active = true;
        this.error.type = "settings"
        this.error.icon = "warning"
        this.error.message = this.$t('alert.widgetSettingsAndCompanySettingsError');
        this.loadingCompData = false;
      }
    },

    checkBranchesData(){
      // PreSelectedBranch is set in widget
      if(this.preSelectedBranch){
        // Check if PreSelectedBranch is correct
        db.collection("branches")
        .doc(this.preSelectedBranch).get()
        .then(doc => {
          if (doc.exists) {
            this.selectedBranch = this.preSelectedBranch;
            this.selectedBranchData = doc.data()
            // PreSelectedBranch is correct
            this.checkForWidgetSettings().then(()=>{
              if(this.widgetSettings.active){
                this.getBranchTreatments()
              }
              this.loadingCompData = false;
            })
            // this.loadTreatmentTypes();
          }
          else{
            // PreSelectedBranch is not correct
             this.getBranchesData();
          }
        })
        .catch(error=>{
          console.error("Fout bij controleren vestiging: ", error)
          this.error.active = true;
          this.error.type = "settings";
          this.error.icon = "warning";
          this.error.message = this.$t('alert.branchesLoadingError');
          this.loadingCompData = false;
        })
      }
      // PreSelectedBranch is not set in widget
      else{
        this.getBranchesData();
      }
      this.nextStepEnabled = true;
    },

    getLeadForm(){
      this.leadsLoading = true;
      this.leadInfo ={
        feedback: {
          type: 'warning',
          icon: 'mdi-alert',
          message: null
        },
        clientId: null,
        firstName: "",
        lastName: "", 
        email: "",
        selectedPhoneLanguage: "+31",
        tel: "",
        questions: [],
        actions: [],
        extra: {
          source: this.source,
          startUrl: this.startUrl,
          executedFrom: this.executedFrom,
          device: this.userAgent,
          userAgent: navigator.userAgent,
          language: this.selectedLanguage.id,
          ip: this.ip,
          type: "bookingwidget",
        }
      };
      this.step = 9;
      
      db.collection("leadCampaigns").doc(this.leadFormId).get()
      .then(doc => {
        if(doc.exists) {
          if(doc.data().companyId == this.company && doc.data().active){
            this.leadCampaignData = doc.data();
            this.leadCampaignData.id = doc.id;
            this.leadInfo.questions = doc.data().questions;

            if(this.leadInfo.questions.length > 0){
              this.leadInfo.questions.forEach(question =>{
                question.value = null;
              })
            }
            this.leadsLoading = false;
          }
          else{
            //console.log("No leadCampaigns found for this company");
            this.step = 0;
            this.leadsLoading = false;
          }
        }
        else {
          this.step = 0;
          //console.log("No leadCampaigns found");
          this.leadsLoading = false;
        }
      })
      .catch(error=>{
        this.step = 0;
        this.leadsLoading = false;
        console.error('Error getting LeadForm' , error)
      })
    },

    sendLeadInfo(){
      this.leadFormPosting = true;
      this.leadInfo.feedback.message = null;
      if(this.leadInformationValid){
        //console.log("Valid Leadform")
        //console.log("Client ID: ", this.leadInfo.clientId);
       
          db.collection("leads")
          .add({
            branch: this.selectedBranch,
            campaign: this.leadCampaignData.id,
            questions: this.leadInfo.questions,
            actions: [],
            actionSpeed: this.leadCampaignData.actionSpeed,
            language: this.language.toLowerCase(),
            type: 'open',
            source: this.source,
            customSource: null,
            startUrl: this.startUrl,
            executedFrom: this.executedFrom,
            device: this.userAgent,
            userAgent: navigator.userAgent,
            language: this.selectedLanguage.id,
            ip: this.ip,
            created: new Date()
          })
          .then((docRef) => {  
            this.createLeadClient(docRef.id).then((clientType)=>{
              console.log("clientType: ", clientType);
              db.collection("leads").doc(docRef.id)
              .set({
                clientId: this.leadInfo.clientId,
                clientType: clientType,
                companyId: this.company,
                clientInfo: {
                  email: this.leadInfo.email,
                  firstName: this.leadInfo.firstName,
                  lastName: this.leadInfo.lastName,
                  phone: `${this.leadInfo.selectedPhoneLanguage}${this.leadInfo.tel}`
                },
              },{merge: true})
              .then(()=>{
                this.step = 10;
                this.leadFormPosting = false;
                console.log("Lead succesfully added");
              })
              .catch(error => {
                this.step = 10;
                this.leadFormPosting = false;
                this.error.message = this.$t('leadErrorMessage')
                console.error("Error adding Lead : ", error);
              });
            })
          })
          .catch(error => {
            this.step = 10;
            this.leadFormPosting = false;
            this.error.message = this.$t('leadErrorMessage')
            console.error("Error adding Lead : ", error);
          });

      }
      else{
        console.log("Leadform not Valid")
        this.leadFormPosting = false;
        this.leadInfo.feedback.message = this.$t('leadFormNotValid')
      }
    },

    async createLeadClient(docId){
      console.log("Client Check")
      const configAxiosPOST = {
        headers: {
          "Content-Type": "application/json",
        }
      };
      let leadTag = {
        id: this.leadCampaignData.id,
        name: this.leadCampaignData.name,
        companyId: this.company,
        type: "lead",
        leadDocId: docId,
        dateAdded: moment().format("X")
      }

      let jsonOBJ = {
        "companyId": this.company,
        "clientEmail": this.leadInfo.email,
        "clientFirstName": this.leadInfo.firstName,
        "clientLastName": this.leadInfo.lastName,
        "clientPhone": `${this.leadInfo.selectedPhoneLanguage}${this.leadInfo.tel}`
      }

      let tags = new Array();
      let phone = null;
      let clientType = "newClient"

      await new Promise((resolve)=>{
        axios
        .post(
          `${this.apiUrl}/postClientExist`,
          jsonOBJ,
          configAxiosPOST
        )
        .then(response => {
          // Client does not exist
          if(response.data.typeExist == 2){
            // Create Client
            let companies = [this.company];
             db.collection("clients").add({
               name: this.leadInfo.firstName,
               surname: this.leadInfo.lastName,
               email: this.leadInfo.email,
               companies: [this.company],
               gender: "",
               emailSubscriptions: {
                 newsletter: false
               },
               health: {
                 macronutrients: {}
               },
               address: {
                 
               },
               phone: `${this.leadInfo.selectedPhoneLanguage}${this.leadInfo.tel}`,
               permissions: {},
               type: "person",
               tags: [leadTag],
               language: this.language.toLowerCase()
             })
             .then((docRef)=>{
               this.leadInfo.clientId= docRef.id;
               console.log("Client check finished")
               resolve();
             })
          }

          // Client bestaat al, maar nog niet bij dit bedrijf
          else if(response.data.typeExist == 1 && response.data.companySet == false){
            // Set company in client doc
            let companies = null;
            
            db.collection("clients").doc(response.data.clientId).get()
            .then(doc => {
              companies = doc.data().companies;
              companies.push(this.company);
              tags = doc.data().tags ? doc.data().tags : new Array();
              tags.push(leadTag);
              tags = [...new Map(tags.map(item =>[item.id, item])).values()];
              phone = doc.data().phone ? doc.data().phone :`${this.leadInfo.selectedPhoneLanguage}${this.leadInfo.tel}`;

            })
            .then(()=>{
              db.collection("clients").doc(response.data.clientId).set({
                companies: companies,
                tags: tags,
                phone: phone
              },{merge: true})
            })
            .then(()=>{
              this.leadInfo.clientId= response.data.clientId;
              console.log("Client check finished")
              resolve();
            })
          }

          // Client bestaat al, ook bij dit bedrijf
          else if(response.data.typeExist == 0 && response.data.companySet == true){
            // Set client Id
             db.collection("clients").doc(response.data.clientId).get()
            .then(doc => {
              tags = doc.data().tags ? doc.data().tags : new Array();
              tags.push(leadTag);
              tags = [...new Map(tags.map(item =>[item.id, item])).values()];
              phone = doc.data().phone ? doc.data().phone :`${this.leadInfo.selectedPhoneLanguage}${this.leadInfo.tel}`;
            })
            .then(()=>{
              db.collection("clients").doc(response.data.clientId).set({
                tags: tags,
                phone: phone
              },{merge: true})
            })
            this.leadInfo.clientId= response.data.clientId;
            console.log("Client check finished")
            resolve();
            clientType = "existingClient"
          }
        })
        .catch(err => {
          this.step = 10;
          this.leadFormPosting = false;
          this.error.message = this.$t('leadErrorMessage');
          console.error("Error axios postClientExist =>", err);
          resolve();
        })
      })  
      return clientType;
    },

    getPreSelectedTreatment(){
      db.collection("treatments").doc(this.preSelectedTreatment).get()
      .then(doc => {
        this.preSelectedTreatmentData = doc.data();
        this.preSelectedTreatmentData.id = doc.id;
        this.preSelectedTreatmentData.selected = false;
        this.preSelectedTreatmentData.type = "treatment";
      })
      .catch(error=>{
        console.error('Error getting Preselected Treatment' , error)
      })
    },

    async checkForWidgetSettings(){
      if(this.selectedBranchData.widgetSettings.useCompanySettings){
        this.widgetSettings = this.compdata.conversion.widget;
      }
      else{
        this.widgetSettings = this.selectedBranchData.widgetSettings;
      }

      if(!this.widgetSettings.active){
        this.step = 6;
        this.error.active = true;
        this.error.type = "settings";
        this.error.icon = "info";
        this.error.message = this.$t('alert.widgetNotAvailable');
      }
      return;
    },

    getBranchesData(){ 
      this.branches = [];
      db.collection("branches")
        .where("companyId", "==", this.company)
        .where("active", "==", true)
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let branch = doc.data();
            branch.id = doc.id;
            branch.selected = false;
            this.branches.push(branch);
          });
        })
        .then(()=>{
          if(this.branches.length == 0){
            this.error.active = true;
            this.error.type = "settings";
            this.error.icon = "info"
            this.error.message = this.$t('alert.noBranches');
          }
          else if(this.branches.length == 1){
            // Select the branch by default if there is only one.
            this.selectedBranch = this.branches[0].id;
            this.selectedBranchData = this.branches[0]
          }
        })
        .then(()=>{
          this.loadingCompData = false;
          // this.loadTreatmentTypes();
        })
        .catch(error=>{
          console.error("Fout bij laden vestigingen: ", error)
          this.error.active = true;
          this.error.type = "settings"
          this.error.icon = "warning"
          this.error.message = this.$t('alert.branchesLoadingError');
          this.loadingCompData = false;
        })
    },

    checkLocalStorage(){
      if (window.localStorage.getItem("clientFirstName")){
        this.firstName = window.localStorage.getItem("clientFirstName");
      }
      if (window.localStorage.getItem("clientLastName")){
        this.lastName = window.localStorage.getItem("clientLastName");
      }
        
      if (window.localStorage.getItem("clientEmail")){
        this.email = window.localStorage.getItem("clientEmail");
      }

      if (window.localStorage.getItem("clientPhoneLang")){
        this.selectedPhoneLanguage = JSON.parse(window.localStorage.getItem("clientPhoneLang"));
      }

      if (window.localStorage.getItem("clientLang")){
        this.selectedLanguage = JSON.parse(window.localStorage.getItem("clientLang"));
        this.setSelectedLanguage();
      } else{
        this.checkLanguage();
      }

      if (window.localStorage.getItem("clientPhone")){
        this.tel = window.localStorage.getItem("clientPhone");
      }

      if (window.localStorage.getItem("clientSaveLocal")){
        this.saveClientInformation = window.localStorage.getItem("clientSaveLocal");
      }

      if (window.localStorage.getItem("policyAgree")) {
        this.terms = window.localStorage.getItem("policyAgree");
      }
    },

    setLocalStorage(){
      console.log("Set local storage")
      if(this.saveClientInformation){
        window.localStorage.setItem("clientFirstName", this.firstName);
        window.localStorage.setItem("clientLastName", this.lastName);
        window.localStorage.setItem("clientEmail" , this.email);
        window.localStorage.setItem("clientPhone" , this.tel);
        window.localStorage.setItem("clientSaveLocal" , this.saveClientInformation);
        window.localStorage.setItem("clientPhoneLang" , JSON.stringify(this.selectedPhoneLanguage));
        window.localStorage.setItem("clientLang" , JSON.stringify(this.selectedLanguage));
        window.localStorage.setItem("policyAgree" , true);
      }
      else {
        window.localStorage.removeItem("clientName");
        window.localStorage.removeItem("clientEmail");
        window.localStorage.removeItem("clientPhone");
        window.localStorage.removeItem("clientSaveLocal");
        window.localStorage.removeItem("clientPhoneLang");
        window.localStorage.removeItem("clientLang");
        window.localStorage.removeItem("policyAgree");
      }
    },

    cancelBookingCheck(){
      // Check if Booking exists

      // Check if Booking is already canceled

      // Check if Booking Time is in te future

      // Check if Event
      
      this.step = 7;
      db.collection("bookingsummary")
        .doc(this.bookingId)
        .get()
        .then(doc => {
          if (!doc.exists) {
            this.cancelBookingLoading = false;
            this.cancelBookingStatus = 'bookingError'
          } 
          else {  
            let maxCancelDate = moment().add(this.compdata.calendarSettings.cancelTimeLimit, "hours").format("YYYY-MM-DDTHH:mm")
            console.log("maxCancelDate: ",  maxCancelDate)

            if(doc.data().start && doc.data().start >= maxCancelDate){
              if(doc.data().type == 'eventbooking'){
                if(this.clientIdBooking){
                  this.cancelBookingData = doc.data();
                  // Check for subscription
                  if (this.cancelBookingData.registrations && this.cancelBookingData.registrations.length > 0) {
                    let clientIndex = _.indexOf(this.cancelBookingData.registrations, this.clientIdBooking);
                    if(clientIndex >= 0){
                      this.cancelBookingLoading = false;
                      this.cancelBookingStatus = 'eventAccepted'
                    }
                    else{
                      this.cancelBookingLoading = false;
                      this.cancelBookingStatus = 'eventClientIdNotRegistered'
                    }
                  }
                  else{
                    this.cancelBookingLoading = false;
                    this.cancelBookingStatus = 'eventClientIdNotRegistered'
                  }
                } 
                else{
                  // Niet genoeg data om uit te schrijven
                  this.cancelBookingLoading = false;
                  this.cancelBookingStatus = 'eventNoClientId'
                }
              }
              else{
                if(!doc.data().deleted){
                  this.cancelBookingData = doc.data();
                  this.cancelBookingStatus = 'bookingAccepted'
                  this.cancelBookingLoading = false;
                }
                else{
                  console.log("Booking is al gecanceled")
                  this.cancelBookingLoading = false;
                  this.cancelBookingStatus = 'bookingCanceled'
                }
              }
            }
            else{
              // Booking cannot be canceled
              if(doc.data().start && doc.data().start <= moment().format("YYYY-MM-DDTHH:mm")){
                console.log("Booking can niet gecanceled worden. De afspraak is al geweest.", doc.data().start)
                this.cancelBookingLoading = false;
                this.cancelBookingStatus = 'bookingInHistory'
              }
              else{
                console.log("Booking can niet gecanceled worden. De afspraak is binnen ", this.compdata.calendarSettings.cancelTimeLimit, "uur", doc.data().start)
                this.cancelBookingLoading = false;
                this.cancelBookingStatus = 'bookingTooClose'
              }
            }
          }
        })
        .catch(error=>{
          this.cancelBookingLoading = false;
          this.cancelBookingStatus = 'bookingError'
          console.error("Error loading booking: ", error)
        })
            

      //     .then(() => {
      //       return new Promise((resolve, reject) => {
      //         console.log("Lengte: ", this.registrationsList.length);
      //         let counterRegistrations = 0;
      //         this.registrationsList.filter((value, index, arr) => {
      //           if (this.clientId == value) {
      //             console.log("Ik match", value);
      //             db.collection("clients")
      //               .doc(this.clientId)
      //               .get()
      //               .then(doc => {
      //                 clientEventMatch = true;
      //                 this.clientInfo.name = doc.data().name;
      //                 this.clientInfo.name = doc.data().surname;
      //                 this.clientInfo.email = doc.data().email;
      //                 this.clientInfo.id = doc.id;
      //               })
      //               .then(() => {
      //                 counterRegistrations++;
      //                 resolve();
      //               })
      //               .catch(error => {
      //                 console.error("Error document: ", error);
      //               });
      //           } else {
      //             counterRegistrations++;
      //           }
      //           console.log("count", counterRegistrations);
      //           if (this.registrationsList.length == counterRegistrations) {
      //             if (clientEventMatch == false) {
      //               console.log("Ik match niet");
      //               this.wolfload = false;
      //               this.validcheck = true;
      //               this.nomatch = true;
      //             }
      //           }
      //         });
      //       }).then(() => {
      //         if (clientEventMatch == true) {
      //           console.log("Ik match");
      //           this.wolfload = false;
      //           this.nomatch = false;
      //           this.validcheck = false;
      //         }
      //       }); //Einde promise
      //     })

      //     .catch(error => {
      //       console.error("Error document: ", error);
      //     });
      // } 
      // else {
      //   let bookingDeleted = true;
      //   
      // }



    },

    checkLanguage(){
      if(this.language != "NL"){
        this.selectedLanguage = this.languages[1];
        this.setSelectedLanguage();
      }
    },

    cancelBooking(){
      db.collection("bookingsummary").doc(this.bookingId).set({
        deleted: true,
        deleteReason: this.cancelBookingReason == 'other' ? this.cancelBookingReasonOther : this.cancelBookingReason,
      }, { merge: true })
      .then(()=>{
        db.collection("bookingen").where("bookingId", "==", this.bookingId).get()
        .then(snapshot => {
          if(snapshot.size > 0 ){
            snapshot.forEach(doc => {
              db.collection("bookingen").doc(doc.id).set({
                dateBooking: 'deleted',
                deleted: {
                  deletedTime: moment().format("YYYY-MM-DDTHH:mm"),
                  deletedBy: this.clientIdBooking,
                  deleteReason: this.cancelBookingReason == 'other' ? this.cancelBookingReasonOther : this.cancelBookingReason,
                  normalDateBooking: doc.data().dateBooking,
                  normalStart: doc.data().start,
                  normalEnd: doc.data().end
                }
              }, { merge: true })
              .catch((error)=>{
                console.error("Error updating booking: ", error)
              })
            })
          }
        })
        .catch(error => {
          console.error("Error getting booking: ", error);
        });
      })
      .then(() => {
        this.step = 8;
        let language = this.language.toLowerCase();
        axios
        .get(`https://deliver.longevityze.nl/cancelMail?doc=${this.bookingId}&activebranch=${this.cancelBookingData.branch}&lang=${language}`)
        .then(response => {
          if(response) { 
            //Email succesfully sent!
          }
        })
        .catch((error) => {
          console.error("Error sending e-mail", error.message);
        });
      })
      .catch((error)=>{
        console.error("Error updating bookingsummary: ", error)
      })
    },

    unsubscribeEvent(){
      let newRegistrations = this.cancelBookingData.registrations.filter(registration => registration != this.clientIdBooking).map(registration => registration);

      db.collection("bookingsummary")
      .doc(this.bookingId)
      .update({
        registrations: newRegistrations
      })
      .then(()=>{
        this.step = 8;
        let language = this.language.toLowerCase();
        axios
        .get(`https://deliver.longevityze.nl/cancelEvent?doc=${this.bookingId}&activebranch=${this.cancelBookingData.branch}&clientId=${this.clientIdBooking}&lang=${language}`)
        .then(response => {
          if(response) { 
            //Email succesfully sent!
          }
        })
        .catch((error) => {
          console.error("Error sending e-mail", error.message);
        });
      })
      .catch((error) => {
        console.error("Error updating bookingsummary", error.message);
      });
    },
    
    getIp() {
      // Get IP info
      axios
        .get(
          `https://pro.ip-api.com/json/?key=M08tSvdEklYEPub&fields=status,message,continentCode,country,countryCode,region,regionName,city,zip,lat,lon,timezone,isp,org,as,mobile,proxy,hosting,query`
        )
        .then(response => {
          // console.log(response.data);
          this.ip = response.data;
        })
        .catch(error => {
          console.error("IP-fetch error", error)
        });
    },

    loaded(id){
      this.employees.forEach(employee =>{
        if(employee.id == id){
          employee.photoLoaded = true;
        }
      })
    },

    checkWindowDates(){
      // Calculate fitting dates to display the dates aligned in center
      let widgetWidth = document.getElementById("widget-content").clientWidth;
      let widgetWidthDates = (document.getElementById("widget-content").clientWidth - 69);

      if(widgetWidthDates <= 400){
        this.dateWidth = 59;
      } 
      else{
        this.dateWidth = 63;
      }
     
      this.windowDates = Math.floor(widgetWidthDates / this.dateWidth);

      this.datesFitWidth = (this.windowDates * this.dateWidth) + 69

      // Calculate fitting timeslot to display the times aligned in center
      let size;
      if(widgetWidth <= 400){
        if(widgetWidth <= 320){
          size = 100;
        }
        else{
          size = 75;
        }     
      }
      else{
        size = 111;
      }
      this.timesFitWidth = Math.floor((widgetWidth - 10) / size) * size;
    },

    selectEmployee(){
      this.availabilityLoading = true;
      this.getAvailability(this.selectedEmployee, 'new')
      let employeeIndex = _.findIndex(this.employees, { 'id': this.selectedEmployee })
      this.selectedEmployeeData = this.employees[employeeIndex]
    },

    getAvailability(employee, type, stayCurrentMonth){   

      //console.log("getAvailability: ", employee, type, stayCurrentMonth)
      let loadAvailability = true;
      let nextMonth = null;

      let loadJustCurrentMonth = false;

      if(this.dateview == 'month'){
        if(type == 'new'){
          let daysLeftInMonth;
          if(this.widgetSettings.startDateActive && this.widgetSettings.startDate && this.widgetSettings.startDate.seconds && (this.widgetSettings.startDate.seconds > moment().format('X'))){
            console.log("Uitzondering in de widget")
            this.activeMonthRaw = moment(this.widgetSettings.startDate.seconds, "X");
            this.activeMonth = moment(this.widgetSettings.startDate.seconds, "X").format("MMMM");
            this.currentDayOfMonth = moment(this.activeMonthRaw).date();  
            daysLeftInMonth = moment(this.activeMonthRaw).daysInMonth() - moment(this.activeMonthRaw).date();
            this.startFrom = this.activeMonthRaw.diff(moment(), 'days') + 1;
          }
          else{
            this.startFrom = 0;
            console.log("GEEN uitzondering in de widget")
            this.activeMonthRaw = moment();
            this.activeMonth = moment().format("MMMM");
            this.currentDayOfMonth = moment().date();  
            daysLeftInMonth = moment().daysInMonth() - moment().date();
          }
          if(daysLeftInMonth > 6){
            loadJustCurrentMonth = true;
            this.numberOfDays = (daysLeftInMonth) + 1;
          }

          else{
            loadJustCurrentMonth = false;
            this.numberOfDays = ((moment(this.activeMonthRaw).daysInMonth() + moment().add(1,'month').daysInMonth()) - this.currentDayOfMonth) + 1;
          }

          this.availabilityLoading = true;
          this.availability = [];
          this.availabilityMonth = [];
          this.selectedDate = null;
          this.selectedSector = null;
          this.selectedTime = null;
          this.timeslots = [];
        }
        else{
          let latestLoadedMonth = Number(moment(this.availability[this.availability.length - 1].thriveDate).format("M"));
          nextMonth = Number(moment(this.activeMonthRaw).add(1,'month').format("M"));
          //console.log("latestLoadedMonth: ", latestLoadedMonth);
          //console.log("nextMonth: ", nextMonth);

          if(nextMonth >= latestLoadedMonth){
            //console.log("Data volgende maand laden.");
            this.availabilityLoadingExtra = true;
          }
          else{          
            // next month is already loaded
            //console.log("Data volgende 2 maanden is al geladen, hoeft dus niet meer");
            loadAvailability = false;
          }

          if(!stayCurrentMonth){
            this.availabilityMonth = [];
            this.activeMonthRaw = moment(this.activeMonthRaw).add(1,'month');
            this.activeMonth = moment(this.activeMonthRaw).format("MMMM");

            this.availability.forEach(day=>{
              if((moment(day.thriveDate).format("M") == moment(this.activeMonthRaw).format("M")) && (moment(day.thriveDate).format("YYYY") == moment(this.activeMonthRaw).format("YYYY"))){
                this.availabilityMonth.push(day);
              }
            })
            if((moment(this.activeMonthRaw).format('M') == moment().format('M')) && (moment(this.activeMonthRaw).format('YYYY') == moment().format('YYYY'))){
              this.showingMonthIsNotCurrentMonth = false;
            }
            else{
              this.showingMonthIsNotCurrentMonth = true;
            }
          }
        }
      }
      else{
        if(type == 'new'){
          this.availabilityMargin = 0;
          this.startFrom = 0;
          this.numberOfDays = 14;
          this.availabilityLoading = true;
          this.availability = [];
          this.selectedDate = null;
          this.selectedTime = null;
          this.timeslots = [];
        }
      }

      if(loadAvailability){
        if(!this.selectedTreatment.eventBooking){ // Selected Treatment is no Event Booking (Grouplesson)
          axios.get(`${this.apiUrl}/getAvailability?token=` + this.cacheToken + '&employee=' + employee + '&start=' + this.startFrom +'&end=' + this.numberOfDays +'&interpreter=checkRange', {
            headers: {
              'Access-Control-Allow-Origin': '*'
            }
          })
          .then((response) => {
            console.log("Availability reponse", response.data.length)
            if(this.dateview == 'month'){
              if(type == 'new'){
                this.availability = response.data;
                this.availabilityMonth = [];
                let currentMonth = moment(this.activeMonthRaw).format("MMMM");
                if(currentMonth == this.activeMonth){
                  let pastDates = [];
                  pastDates = Array((this.currentDayOfMonth - 1)).fill('emptyDay');
                  let startOfMonth =  moment().startOf('month')

                  if(pastDates.length > 0){
                    pastDates.forEach((day, index)=>{
                      let emptySlot = {
                        selected: false,
                        thriveDate: moment(startOfMonth).add(index, 'days').format("YYYY-MM-DD"),
                        thriveSlots: []
                      };
                      this.availabilityMonth.push(emptySlot);
                    })
                  }
                }

                this.availability.forEach(day=>{
                  if(moment(day.thriveDate).format("M") == moment(this.activeMonthRaw).format("M")){
                    this.availabilityMonth.push(day);
                  }
                })
                this.searchFirstPossibleDay();
              }
              else{
                this.availabilityLoadingExtra = false;
                this.availability = this.availability.concat(response.data);
              }

              this.startFrom = this.startFrom + this.numberOfDays;

              let latestLoadedMonth = moment(this.availability[this.availability.length - 1].thriveDate);
              
              this.numberOfDays = Number(moment(latestLoadedMonth).add(1,'month').daysInMonth());
    

              if(loadJustCurrentMonth){
                console.log("B: Volgende maand vast laden")
                this.getAvailability(this.selectedEmployee, 'extend', true);
              }
              else{
                console.log("B: Volgende maand is al geladen");
              }
            }
            else{
              if(type == 'new'){
                this.availability = response.data;
                this.searchFirstPossibleDay();
                this.startFrom = this.startFrom + this.numberOfDays;
                this.numberOfDays = 7;
              }
              else{
                this.availability = this.availability.concat(response.data);
                this.startFrom = this.startFrom + 7;
              }
            }
            
            this.availabilityLoading = false;
            this.updateConversionData();   
          })
          .catch((error)=>{
            this.apiError = {
              cacheId: this.cacheToken,
              log: "getAvailability error: " + JSON.stringify(error)
            };
            this.availabilityLoading = false;
            this.availabilityLoadingExtra = false;
            console.error("error: ", error)
          }) 
        }
        else{ // Selected Treatment is no Event Booking (Grouplesson)
          console.log("EVENT BOOKING")
          this.selectedTreatment.eventBookingData.events = new Array();
          console.log("Groepsles MTFK: startFrom", this.startFrom, "numberOfDays",this.numberOfDays)
          // ${this.apiUrl}/getBookingSubscriptions?token=VU7KmD8iYyCuHmsaom43&treatmentId=1iP25pn4YUVRbUcAVWfr&start=0&end=14
          axios.get(`${this.apiUrl}/getBookingSubscriptions?token=` + this.cacheToken + '&treatmentId=' + this.selectedTreatment.eventBooking + '&start=' + this.startFrom +'&end=' + this.numberOfDays, {
            headers: {
              'Access-Control-Allow-Origin': '*'
            }
          })
          .then((response) => {
            let events = new Object();
            let counter = 0;
            let availabilityEvents = new Array()

            new Promise((resolve)=>{
              response.data.forEach(event=>{
                let eventDateId = moment(event.date).format("YYYYMMDD")

                if(events[eventDateId]){
                  events[eventDateId].events.push(event);
                  if(event.availableSeats > 0){
                    events[eventDateId].availableSlots = events[eventDateId].availableSlots + 1;
                  }
                }
                else{
                  availabilityEvents.push({thriveDate: event.date})
                  events[eventDateId] = {
                    date: event.date,
                    events: new Array(),
                    availableSlots: 0,
                    duration: event.duration
                  };
                  if(event.availableSeats > 0){
                    events[eventDateId].availableSlots = events[eventDateId].availableSlots + 1;
                  }
                  events[eventDateId].events.push(event);
                }
                counter++
                if(counter == response.data.length){
                  resolve()
                }
              })
            })
            .then(()=>{
              if(type == 'new'){
                this.availability = availabilityEvents;
                this.availabilityMonth = [];

                let currentMonth = moment(this.activeMonthRaw).format("MMMM");
                if(currentMonth == this.activeMonth){
                  let pastDates = [];
                  pastDates = Array((this.currentDayOfMonth - 1)).fill('emptyDay');
                  let startOfMonth =  moment().startOf('month')

                  if(pastDates.length > 0){
                    pastDates.forEach((day, index)=>{
                      let emptySlot = {
                        selected: false,
                        thriveDate: moment(startOfMonth).add(index, 'days').format("YYYY-MM-DD"),
                        thriveSlots: []
                      };
                      this.availabilityMonth.push(emptySlot);
                    })
                    // Generate days in the future. (Grouplessons are not every day). 
                    this.availability = new Array(moment(this.activeMonth, "MMMM").daysInMonth() - pastDates.length).fill({selected: false, thriveDate: null})
                  }
                  else{
                    // Generate days in the future. (Grouplessons are not every day). 
                    this.availability = new Array(moment(this.activeMonth, "MMMM").daysInMonth()).fill(0)
                  }
                }
                else{
                  // Generate days in the future. (Grouplessons are not every day). 
                  this.availability = new Array(moment(this.activeMonth, "MMMM").daysInMonth()).fill(0)
                }

                let activeDay = moment().format("YYYYMMDD"); // Set date of today to start counting
                let bookingEventAvailability = new Array(); // New array to fill with dates and availability

                this.availability.forEach(day=>{
                  let eventBookingSlot = {
                    selected: false,
                    thriveDate: moment(activeDay,"YYYYMMDD").format("YYYY-MM-DD"),
                    thriveSlots: []
                  };
                  bookingEventAvailability.push(eventBookingSlot);

                  if(moment(activeDay,"YYYYMMDD").format("M") == moment(this.activeMonthRaw).format("M")){ // Month is equal
                    if(events[activeDay] && events[activeDay].availableSlots > 0){ // This date has events with available slots
                      eventBookingSlot.thriveSlots = events[activeDay].events
                    }
                    this.availabilityMonth.push(eventBookingSlot);
                  }
                  activeDay = moment(activeDay,"YYYYMMDD").add(1, 'days').format("YYYYMMDD"); // Add one day for next availability item
                })
                this.availability = bookingEventAvailability;
                this.searchFirstPossibleDay();
              }
              else{
                this.availabilityLoadingExtra = false;
                let nextMonthAvailability = new Array(moment(nextMonth, "M").daysInMonth()).fill(0); // Set next month
                let bookingEventAvailability = new Array(); // New array to fill with dates and availability

                let activeDay = moment(nextMonth, "M").startOf('month').format("YYYYMMDD"); // Set first date of the month to start counting

                nextMonthAvailability.forEach(day=>{
                  let eventBookingSlot = {
                    selected: false,
                    thriveDate: moment(activeDay,"YYYYMMDD").format("YYYY-MM-DD"),
                    thriveSlots: []
                  };
                  if(events[activeDay] && events[activeDay].availableSlots > 0){ // This date has events with available slots
                    eventBookingSlot.thriveSlots = events[activeDay].events
                  }
                  bookingEventAvailability.push(eventBookingSlot);
                  activeDay = moment(activeDay,"YYYYMMDD").add(1, 'days').format("YYYYMMDD"); // Add one day for next availability item
                })
                this.availability = this.availability.concat(bookingEventAvailability);
              }

              this.startFrom = this.startFrom + this.numberOfDays;
              let latestLoadedMonth = moment(this.availabilityMonth[this.availabilityMonth.length - 1].thriveDate);             
              this.numberOfDays = Number(moment(latestLoadedMonth).add(1,'month').daysInMonth());

              this.availabilityLoading = false;
              this.updateConversionData(); 

              if(loadJustCurrentMonth){
                console.log("B: Volgende maand vast laden")
                this.getAvailability(0, 'extend', true);
              }
              else{
                console.log("B: Volgende maand is al geladen");
              }  
            })
          })
          .catch((error)=>{
            this.apiError = {
              cacheId: this.cacheToken,
              log: "getBookingSubscriptions error: " + JSON.stringify(error)
            };
            this.availabilityLoading = false;
            console.error("getBookingSubscriptions error: ", error)
          }) 
        }
      }       
    },

    availabilityPrevious(){
      if(this.dateview = 'month'){
        
        this.emptySelectedDate();
        this.selectedDate = null;
        this.timeslots = [];
        this.availabilityMonth = [];
        
        this.activeMonthRaw = moment(this.activeMonthRaw).subtract(1,'month');
        this.activeMonth = moment(this.activeMonthRaw).format("MMMM");
        let currentMonth = moment().format("MMMM");
        if(currentMonth == this.activeMonth){
          let pastDates = [];
          pastDates = Array((this.currentDayOfMonth - 1)).fill('emptyDay');
          let startOfMonth =  moment().startOf('month')

          if(pastDates.length > 0){
            pastDates.forEach((day, index)=>{
              let emptySlot = {
                selected: false,
                thriveDate: moment(startOfMonth).add(index, 'days').format("YYYY-MM-DD"),
                thriveSlots: []
              };
              this.availabilityMonth.push(emptySlot);
            })
          }
        }
        this.availability.forEach(day=>{
          if((moment(day.thriveDate).format("M") == moment(this.activeMonthRaw).format("M")) && (moment(day.thriveDate).format("YYYY") == moment(this.activeMonthRaw).format("YYYY"))){
            this.availabilityMonth.push(day);
          }
        })
        if((moment(this.activeMonthRaw).format('M') == moment().format('M')) && (moment(this.activeMonthRaw).format('YYYY') == moment().format('YYYY'))){
          this.showingMonthIsNotCurrentMonth = false;
        }
        else{
          this.showingMonthIsNotCurrentMonth = true;
        }
      }
      else{
        this.availabilityMargin = this.availabilityMargin + (this.dateWidth*this.windowDates);
      }   
    },

    availabilityNext(){
      this.emptySelectedDate();
      if(this.dateview = 'month'){
        this.selectedDate = null;
        this.timeslots = [];
      }
      this.availabilityMargin = this.availabilityMargin - (this.dateWidth*this.windowDates);
      this.getAvailability(this.selectedEmployee, 'extend');
    },

    checkAvailabilityEvent(event){
      // Check if event is full
      if(event.maxPersons <= event.registrations.length){
        return false;
      }
      else{
        return true;
      }
    },

    checkBookingAvailabilityEvent(event){
      // Check if event is available for booking
      let data = {
        reason: "",
        available: true,
        timeBetween: null
      }

      let maxTimeLimit = true;
      let minTimeLimit = true;

      // Time between subscription and start Event
      let startTime = moment(event.startFormatted, 'YYYY-MM-DDTHH:mm')
      let now = moment();
      var duration = moment.duration(startTime.diff(now));
      data.timeBetween = (duration.asHours()).toFixed(2);

      // maxTimeLimit = Time between subscription and start Event
      // minTimeLimit = Time between subscription and start Event

      if(event.maxTimeLimitSubscription){
        if(event.maxTimeLimitSubscription < data.timeBetween){
          maxTimeLimit = false;
          data.reason = "maxLimit";
        }
      }
      
      if(event.minTimeLimitSubscription){
        if(event.minTimeLimitSubscription > data.timeBetween){
          minTimeLimit = false;
          data.reason = "minLimit";
        }
      }

      if(!maxTimeLimit || !minTimeLimit){
        data.available = false;
      }
      
      return data;
    },

    eventDuration(selectedEvent){
      if(selectedEvent.startFormatted && selectedEvent.end){
        let startTime = moment(selectedEvent.startFormatted, 'YYYY-MM-DDTHH:mm')
        let endTime = moment(selectedEvent.end, 'YYYY-MM-DDTHH:mm')
        var duration = moment.duration(endTime.diff(startTime));
        return (duration.asMinutes()).toFixed(0);
      }
      else{
        return null;
      } 
    },
              
    selectBranch(branch){
      this.selectedBranch = branch.id;
      this.selectedBranchData = branch;
      this.checkForWidgetSettings();
      this.next();
    },
    
    selectTreatment(type, data, treatmentIndex, treatmentTypeIndex){
      // console.log("selectTreatment function uitgevoerd")
      if(type == 'treatment'){
        if(data.type == 'treatment'){
          this.selectedTreatment.type = 'treatment';
          this.selectedTreatment.event = null;
          this.selectedTreatment.eventBooking =  data.eventBooking ? data.id : null;
          this.selectedTreatment.eventData = null;
          this.selectedTreatment.noEmployeeSubtreatment = false;
          this.selectedEvent = null;
          this.selectedTreatment.eventBookingData = data.eventBooking ? data : null;

          // SELECT & DESELECT TREATMENTS & PUSH SELECTED-TREATMENT-DATA

          if(!this.multiTreatmentBooking){
            this.selectedTreatment.treatments = [];
            this.selectedTreatment.treatmentsData = [];
          }
          
          this.treatmentTypes.forEach(treatmentType=>{
            treatmentType.treatments.forEach(treatment=>{
              if(treatment.id){
                if(treatment.id == data.id){
                  if(treatment.selected == false){
                    treatment.selected = true;
                    this.selectedTreatment.treatments.push(data.id);
                    this.selectedTreatment.treatmentsData.push(data);
                    this.selectedTreatment.noEmployeeSubtreatment = treatment.noEmployeeSubtreatment ? treatment.noEmployeeSubtreatment : false;
                    
                  } 
                  else{
                    treatment.selected = false;
                    let index = _.findIndex(this.selectedTreatment.treatments, data.id);
                    let dataIndex = _.findIndex(this.selectedTreatment.treatmentsData, {'id': data.id });
                    this.selectedTreatment.treatments.splice(index,1);
                    this.selectedTreatment.treatmentsData.splice(dataIndex,1);
                  }
                }
                else{
                  if(!this.multiTreatmentBooking){
                    treatment.selected = false;
                  }
                }
              }
              else{
                treatment.selected = false;
              }   
            })
          })
          this.treatments.forEach(treatment=>{
            if(treatment.id){
              if(treatment.id == data.id){
                if(treatment.selected == false){
                  treatment.selected = true;
                }
              }
              else{
                treatment.selected = false;
              }
            }
            else{
              if(!this.multiTreatmentBooking){
                treatment.selected = false;
              }
            } 
          })
          if(this.treatmentTypesFiltered.treatments && this.treatmentTypesFiltered.treatments.length > 0){
            this.treatmentTypesFiltered.treatments.forEach(treatment=>{ 
              if(treatment.id){
                if(treatment.id == data.id){
                  if(treatment.selected == false){
                    treatment.selected = true;
                  }
                  else{
                    treatment.selected = false;
                  }
                }
              }
              else{
                if(!this.multiTreatmentBooking){
                  treatment.selected = false;
                }
              } 
            })
          }
          
          this.calculateTotalTreatmentPrice();

          this.availabilityLoading = true;
          if(!this.selectedTreatment.eventBooking){
            this.getEmployees().then((result)=>{
              if(result){
                this.getAvailability(0, 'new');
              }
            })
          } 
          else{
            this.getAvailability(0, 'new');
          }
            
        }
        else{
          this.selectedTreatment.type = 'event';
          this.selectedTreatment.treatments = [];
          if(this.selectedTreatment.event == data.eventSummaryId){
            // DESELECT EVENT
            this.selectedTreatment.event = null;
            this.selectedTreatment.eventData = null;
            this.selectedEvent = null;
            if(treatmentTypeIndex){
              this.treatmentTypes[treatmentTypeIndex].treatments[treatmentIndex].selected = false;
            }
            else{
              if(this.treatments && this.treatments.length > 0){
                this.treatments.forEach(treatment=>{
                  treatment.selected = false;
                })
              }
              if(this.treatmentTypesFiltered.treatments && this.treatmentTypesFiltered.treatments.length > 0){
                this.treatmentTypesFiltered.treatments.forEach(treatment=>{
                  treatment.selected = false;
                })
              }   
            }
          }
          else{
            // SELECT EVENT & DESELECT TREATMENTS
            this.selectedTreatment.event = data.eventSummaryId;
            this.selectedTreatment.eventData = data;
            this.treatmentTypes.forEach(treatmentType=>{
              treatmentType.treatments.forEach(treatment=>{

                if(treatment.bookingSummaryId == data.bookingSummaryId){
                  treatment.selected = true;
                }
                else{
                  treatment.selected = false;
                } 
              })
            })

            this.treatments.forEach(treatment=>{
              if(treatment.bookingSummaryId && treatment.bookingSummaryId == data.bookingSummaryId){
                treatment.selected = true;
              }
              else{
                treatment.selected = false;
              }
            })
          } 
        }

        this.events.forEach(event=>{
          event.selected = false;
        })  
      }
      
      else{
      // Special Event
        this.selectedTreatment.type = 'event';
        this.selectedTreatment.treatments = [];

        if(this.selectedTreatment.event == data.eventSummaryId){
          // DESELECT EVENT
          this.selectedTreatment.event = null;
          this.selectedTreatment.eventData = null;
          this.selectedEvent = null;
          this.events.forEach(event=>{
            event.selected = false;
          })  
        }
        else{
          // SELECT EVENT & DESELECT TREATMENTS
          this.selectedTreatment.event = data.eventSummaryId;
          this.selectedTreatment.eventData = data;

          this.treatmentTypes.forEach(treatmentType=>{
            treatmentType.treatments.forEach(treatment=>{
              treatment.selected = false;
            })
          })
          
          this.treatments.forEach(treatment=>{
            treatment.selected = false;
          })

          this.events.forEach(event=>{
            if(event.eventSummaryId == data.eventSummaryId){
              event.selected = true;
            }
            else{
              event.selected = false;
            }   
          })
        }
      }

      if(this.selectedTreatment.treatments.length > 0 || this.selectedTreatment.event){
        // console.log("Item Selected")
        this.treatmentSelected = true;
        if(this.selectedTreatment.treatments.length > 0){
           // console.log("Treatment Selected: ", treatmentTypeIndex)
          if(treatmentTypeIndex == (this.treatmentTypes.length - 1)){
            if(treatmentIndex == (this.treatmentTypes[treatmentTypeIndex].treatments.length - 1)){      
              setTimeout(()=>{
                this.scrollToTreatmentsBottom();
              }, 250);
            }
          }
        }
        else if(this.selectedTreatment.event){
          // console.log("event Selected: ", treatmentIndex)
          if(treatmentIndex == (this.events.length - 1)){
            setTimeout(()=>{
              this.scrollToTreatmentsBottom();
            }, 250);
          }
        }
        
      }
      else{
        this.treatmentSelected = false;
      }
    },

    calculateTotalTreatmentPrice(){
      this.totalTreatmentPrice = 0;
      this.treatments.forEach(treatment=>{
        if(treatment.selected){
          this.totalTreatmentPrice = this.totalTreatmentPrice + treatment.treatmentPrice;
        }
      })

      if(this.selectedTreatment.treatments.length > 1 && this.showPrices){
        var element = document.getElementById("total-price");
        element.classList.add("run-animation");
        setTimeout(function(){
        	element.classList.remove("run-animation");
        }, 500);
      } 
    },
    
    setSelectedLanguage() {
      this.$i18n.locale = this.selectedLanguage.code;
      this.$moment.locale((this.selectedLanguage.code).toLowerCase())
      this.todayFormatted = moment().format("ddd");
    },

    closeWidget() {
      let widgetObject = { message: "widgetKill", url: null };
      this.$emit("showWidgetDialog", false);
      if (this.userAgent == "mobile") {
        window.location.href = this.compdata.url;
      } 
      else{
        parent.postMessage(widgetObject, "*")
      }
      if(this.step == 5){
        this.resetWidgetData();
      }
    },

    resetWidgetData(){
      // Reset widget
      this.step = 0;
      this.firstName = null;
      this.lastName = null;
      this.email = null;
      this.tel = null;
      this.treatments = [];
      this.selectedTreatment.treatments = [];
      this.selectedTreatment.treatmentsData = [];
      this.selectedTreatment.event = null;
      this.selectedTreatment.eventData = null;
      this.selectedTreatment.noEmployeeSubtreatment = false;
      this.availability = [];
      this.availabilityMonth = [];
      this.selectedDate = null,
      this.selectedTime = null
      this.selectedSector = null;
      this.timeslots = [];
      this.feedback.message = null;
      this.docId = null;
      this.apiError = null;
      this.cancelBookingCheck = false;
      this.bookingId = null;
      this.cancelBookingData = null;
      this.clientIdBooking = null;
      this.cancelBookingReason = null;
      this.cancelBookingReasonOther = null;
      this.leadCampaignData = null;
      this.leadsLoading = false;
      this.leadFormPosting = false;
    },

    numberWithCommas(x) {
      let price = Number(x.toFixed(2));
      return price.toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' });
    },

    async checkDownPaymentSetting(){
      console.log("checkDownPaymentSetting")
      this.downPaymentRequired = false;



      // Check if downpayment is required
      if(this.selectedBranchData.widgetSettings && this.selectedBranchData.widgetSettings.downPayments && this.selectedBranchData.widgetSettings.downPayments.active){
        let downPaymentMandatory = true;
        if(this.selectedBranchData.widgetSettings.downPayments.onlyNewClients){ // Alle klanten of alleen nieuwe klanten
          const configAxiosPOST = {
            headers: {
              "Content-Type": "application/json",
            }
          };
          let jsonOBJ = {
            "companyId": this.compdata.id,
            "clientEmail": this.email,
            "clientFirstName": this.firstName,
            "clientLastName": this.lastName,
            "clientPhone": `${this.selectedPhoneLanguage}${this.tel}`
          };
          await axios.post(`${this.apiUrl}/postClientExist`, jsonOBJ, configAxiosPOST)
          .then(response => {
            console.log("postClientExist: ", response)
            if(response.data.typeExist == 0 && response.data.companySet == true){ // Client bestaat al, ook bij dit bedrijf
              downPaymentMandatory = false;
            }
          })
          .catch(err => {
            console.error("Error axios postClientExist =>", err);
          })
        }

        if(downPaymentMandatory){
          // Check if Mollie settings are there
          let settingsSource = this.selectedBranchData.connections && this.selectedBranchData.connections.mollie && this.selectedBranchData.connections.mollie.useBranchConnection ? 'selectedBranchData': 'compdata';

          if(this[settingsSource].connections && this[settingsSource].connections.mollie && this[settingsSource].connections.mollie.refreshToken && this[settingsSource].connections.mollie.profileId){ // Controleren of Mollie actief is
            axios.post(`https://connections.thrive365.nl/mollie/checkup`, {refreshToken:this[settingsSource].connections.mollie.refreshToken})
            .then((response) => {
              console.log("Mollie checkup Response: ", response)
              this.downPaymentRequired = true;
            })
            .catch(error=> {  
              console.error("Error checkup Mollie", error)
              this.downPaymentRequired = false;
            })
          }
          else{ // Mollie is niet actief
            console.log("Mollie is niet actief of niet goed ingesteld")
            this.downPaymentRequired = false;
          }
        }
        else{ // Client already known
          this.downPaymentRequired = false;
        }
      }
      else{ // Downpayment is NOT required
        this.downPaymentRequired = false;
      }
    },
    

    async setClientCache(){
      // console.log("Create Client Cache")
      // API Call to create user cache file
      await axios.post(`${this.apiUrl}/postClientCache`, {
        "thriveCompany" : {
          "companyId" : this.company,
          "branchId" : this.selectedBranch
        },
        "thriveClient": {
          "name": this.firstName,
          "surname": this.lastName,
          "email": this.email,
          "tel": this.selectedPhoneLanguage.phone + this.tel
        },
        headers: { 
          'Content-Type': 'application/json'
        },
      })
      .then((response) => {
        this.cacheToken = response.data;
        this.setLocalStorage();
        this.checkDownPaymentSetting()
      })
      .catch((error)=>{
        this.apiError = {
          cacheId: null,
          log: "postClientCachee error: " + JSON.stringify(error)
        };
        console.error("error: ", error)
      })          
    },

    async getEmployees(){
      this.employees = [
        {
          id: 0,
          name:  this.$t('noPreference')
        }
      ];
      this.employeesLoading = true;
      let treatments = this.selectedTreatment.treatments.toString()
      let getEmployeesApi = false;
      
      if(treatments){
        // API Call to create user cache file
        await axios.get(`${this.apiUrl}/getEmployees?token=` + this.cacheToken + '&treatment=' + treatments)
        .then((response) => {
          response.data.forEach(employee=>{
            if(employee.photo){
              employee.photoLoaded = false;
            }
            this.employees.push(employee)
          })
          getEmployeesApi = true;
        })
        .catch((error)=>{
          this.apiError = {
            cacheId: this.cacheToken,
            log: "getEmployees error: " + JSON.stringify(error)
          };
          console.error("error: ", error)
          getEmployeesApi = false;
        })
        this.employeesLoading = false;
        return getEmployeesApi;  
      }
      else{
        this.employeesLoading = false;
        return getEmployeesApi;
      }     
    },

    searchFirstPossibleDay(){
      let availability

      if(this.dateview =='month'){
        availability = this.availabilityMonth;
      }
      else{
        availability = this.availability;
      }
      for (let i = 0; i < availability.length; i++) {
        if(availability[i].thriveDate < moment().format("YYYY-MM-DD")){
          availability[i].thriveSlots = [];
        }
        else{
          if(availability[i].thriveSlots.length > 0){
            this.firstPossibleDay = {
              index: i,
              day: availability[i].thriveDate,
              time: availability[i].thriveSlots[0].timeStart
            }
            break
          }
        } 
      }
    },

    emptySelectedDate(){
      this.availabilityMonth.forEach(date=>{
        date.selected = false;
      });
      this.availability.forEach(date=>{
        date.selected = false;
      });
    },

    selectDate(index){
      this.emptySelectedDate();
      this.selectedSector = String(this.availabilityMonth[index].sector);
      
      if(this.dateview == 'month'){
        this.availabilityMonth[index].selected = true;
        this.selectedDate = this.availabilityMonth[index].thriveDate;

        if(this.availabilityMonth[index].thriveSlots.length > 0){
          this.timeslots = this.availabilityMonth[index].thriveSlots;
        }
      }
      else{
        this.availability[index].selected = true;
        this.selectedDate =  this.availability[index].thriveDate;

        if(this.availability[index].thriveSlots.length > 0){
          this.timeslots = this.availability[index].thriveSlots;
        }
      }

      if(this.dateview == 'month'){
        setTimeout(function(){ 
          let availableTimesDiv = document.getElementById("timeslots");
          availableTimesDiv.scrollIntoView();
        }, 100);
        
        // var container = this.$el.querySelector("#timeslots");
        // container.scrollTop = container.scrollHeight;
        // scroll to #timeslots
      }
      
      this.updateConversionData();  
    },

    timeSelect(time){
      this.selectedTime = time;
      this.selectedTime.sector = this.selectedSector;
      this.step = 4;
      this.updateConversionData();
    },

    selectEvent(event){
      this.selectedEvent = event;
      this.selectedDate =  moment(event.startFormatted, 'YYYY-MM-DDTHH:mm') .format("YYYY-MM-DD")
      this.selectedTime = {
        timeStart: moment(event.startFormatted, 'YYYY-MM-DDTHH:mm') .format("HH:mm")
      };
      this.step = 4;
      this.updateConversionData();
    },

    selectEventBooking(event){
      this.selectedEventBooking = event;
      this.selectedDate =  moment(event.date) .format("YYYY-MM-DD")
      this.selectedTime = {
        timeStart: event.startTime
      };
      this.step = 4;
      this.updateConversionData();
    },

    selectBookingEvent(event){
      this.selectedBookingEvent = event;
    },

    scrollToTreatmentsBottom(){
      let objDiv = document.querySelector('.widget-content');
      objDiv.scroll({
        top: objDiv.scrollHeight,
        behavior: "smooth"
      });
    },

    async getBranchTreatments(options){
      this.loadingTreatments = true;
      // API Call to create user account
      //console.log("treatmentTypes: ", this.treatmentTypes)
      
      await axios.get(`${this.apiUrl}/getTreatments?companyId=` + this.company + '&branchId='+ this.selectedBranch + '&showTreatment=online&showEvents=true')
      .then((response) => {
        this.treatmentsGender = {
          female: response.data.treatmentsWoman,
          male: response.data.treatmentsMan
        };

        this.treatments = response.data.treatments;
        this.treatmentTypes = response.data.treatmentTypes;
        this.events = response.data.events;
        if(!options || options != 'waitForCache'){
          this.loadingTreatments = false;
        }
        //this.getTreatmentsLocal();
      })
      .catch((error)=>{
        this.loadingTreatments = false;
        console.error("error: ", error)
        return 
      })          
    },

    confirmBooking(){
      if(this.selectedTreatment.treatments.length > 0){
        this.preBookTreatment();
      }
      else{
        this.bookEvent();
      }
    },

    calculateDownPaymentAmount(){
      this.downPaymentAmount = 0;
      if(this.downPaymentRequired){
        let counter = 0;
        let price = 0;
        new Promise((resolve)=>{
          this.selectedTreatment.treatmentsData.forEach(treatment=>{
            price = treatment.treatmentPrice ? price + treatment.treatmentPrice: price;
            counter++
            if(counter == this.selectedTreatment.treatmentsData.length){
              resolve()
            }
          })
        })
        .then(()=>{
          if(!this.selectedBranchData.widgetSettings.downPayments.certainTreatments || price > this.selectedBranchData.widgetSettings.downPayments.certainTreatmentsAmount){
            this.downPaymentAmount = (price / 100) * this.selectedBranchData.widgetSettings.downPayments.percentage;
            this.downPaymentAmount = this.downPaymentAmount > this.selectedBranchData.widgetSettings.downPayments.maximum ? this.selectedBranchData.widgetSettings.downPayments.maximum : this.downPaymentAmount;
            this.downPaymentAmount = this.downPaymentAmount < this.selectedBranchData.widgetSettings.downPayments.minimum ? this.selectedBranchData.widgetSettings.downPayments.minimum : this.downPaymentAmount;
          }
          else{
            this.downPaymentAmount = 0;
          }
          console.log("downPaymentAmount: ", (this.downPaymentAmount).toFixed(2))
        })
      }   
    },

    async confirmBookingWithDownPayment(uniqIdStamp, clientId, type){
      console.log("confirmBookingWithDownPayment: ", (this.downPaymentAmount).toFixed(2))

    
      let settingsSource = this.selectedBranchData.connections && this.selectedBranchData.connections.mollie && this.selectedBranchData.connections.mollie.useBranchConnection ? 'selectedBranchData': 'compdata';

      //axios.post(`https://connections.thrive365.nl/mollie/makePayment`, {
       axios.post(`http://localhost:3002/mollie/makePayment`, {
         code: uniqIdStamp,
         value: (this.downPaymentAmount).toFixed(2),
         currency: "EUR",
         testmode: true,
         company: this.compdata.id,
         branch: this.selectedBranchData.id,
         url: this.compdata.url,
         lang: this.selectedLanguage.id,
         description: `Aanbetaling ${this.compdata.name}: ${uniqIdStamp}`,
         locale: this.selectedLanguage.id = 'nl' ? 'nl_NL' : 'en_US',
         refreshToken: this[settingsSource].connections.mollie.refreshToken,
         profileId: this[settingsSource].connections.mollie.profileId,
         settingsSource: settingsSource,
         clientId: clientId,
         type: type
      })
      .then((response) => {
        console.log("Mollie Payment Response: ", response)
        // Onderstaande gebeurd nu in de connections API

        // db.collection("prepayments").add({ 
        //   timestamp: new Date(),
        //   clientId: clientId,
        //   type: type,
        //   testmode: response.data.mode == 'test' ? true : false,
        //   paymentStatus: 'open',
        //   organisationType: settingsSource == 'selectedBranchData' ? 'branch' : 'company', 
        //   companyId: this.compdata.id,
        //   branchId: settingsSource == 'selectedBranchData' ? this.selectedBranchData.id : null, 
        //   amount: {
        //     number: this.downPaymentAmount,
        //     currency: "EUR",
        //   },
        //   molliePaymentId: response.data.id,
        //   uniqIdStamp: uniqIdStamp,
        //   status: {
        //     returned: false,
        //     type: null,
        //     timestamp: null,
        //     receiptId: null
        //   }
        // })
        // .then(()=>{
        //   this.posting = false;
        //   if(response.data._links.checkout.href){
        //     window.parent.location.href = response.data._links.checkout.href;
        //   } 
        // })
        this.posting = false;
        if(response.data._links.checkout.href){
          window.parent.location.href = response.data._links.checkout.href;
        } 
        
      })
      .catch(error=> {  
        this.posting = false;
        console.error("Error checkup Mollie", error)
      })

    },
    
    confirmEventBooking(){
      this.preBookEventBooking();
    },

    preBookEventBooking(){
      this.posting = true;
      // ${this.apiUrl}/postBookingSubscriptions?token=VU7KmD8iYyCuHmsaom43&treatmentId=1iP25pn4YUVRbUcAVWfr&date=2021-07-21&startTime=08:45
      console.log("preBookEventBooking data: token=" + this.cacheToken + '&treatmentId=' + this.selectedTreatment.eventBooking + '&date=' + this.selectedDate +'&startTime=' + this.selectedTime.timeStart )

       axios.get(`${this.apiUrl}/postBookingSubscriptions?token=` + this.cacheToken + '&treatmentId=' + this.selectedTreatment.eventBooking + '&date=' + this.selectedDate +'&startTime=' + this.selectedTime.timeStart, {
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      })
      .then((response) => {
        // console.log(this.cacheToken, this.selectedEmployee, this.selectedDate, this.selectedTime.timeStart)
        // console.log("Response preBookEventBooking: ", response.data)

        if(response.data.status = 'subscribed' ){
          if (this.confirmEmail && response.data.id && response.data.clientId) {
            axios
              // .get(`http://localhost:9993/confirmSubscription?doc=${this.eventBookingId}&activebranch=${this.activeBranch}&clientId=${this.selectedClient.id}&lang=nl&editable=true`)
              .get(`https://deliver.longevityze.nl/confirmSubscription?doc=${response.data.id}&activebranch=${this.selectedBranch}&clientId=${response.data.clientId}&lang=${this.selectedLanguage.id}`)
              .then((response) => {
                if (response) {
                  // console.log("Email confirmSubscription send")
                  //Email succesfully sent!
                }
              })
              .catch((error) => {
                console.error(error.message);
              });
          }


          this.completeConversionData();
          this.feedback.message = null;
          if(this.compdata.conversion && this.compdata.conversion.successUrl){
            let widgetObject = { message: "widgetKill", url: this.compdata.conversion.successUrl };
            
            parent.postMessage(widgetObject, "*")
            this.$emit("showWidgetDialog", false);
            this.resetWidgetData();
          }
          else{
            this.step = 5;
          }
        }
        else if(response.data.status = 'allreadySubscribed'  ){
          this.feedback.type = 'warning';
          this.feedback.icon = 'mdi-alert';
          this.feedback.message = this.$t('alert.eventBookingAllreadySubscribed');
        }
        else{
          this.feedback.type = 'warning';
          this.feedback.icon = 'mdi-alert';
          this.feedback.message = this.$t('alert.registrationErrorMessage');
        }
      })
      .catch(error=>{
        this.posting = false;
        console.error("preBookEventBooking error: ", error)
      })
    },

    preBookTreatment(){
      this.posting = true;
      let status = null
      axios.get(`${this.apiUrl}/getAvailability?token=` + this.cacheToken + '&employee=' + this.selectedEmployee + '&date=' + this.selectedDate +'&timeStart=' + this.selectedTime.timeStart +'&interpreter=validation', {
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      })
      .then((response) => {
        // console.log(this.cacheToken, this.selectedEmployee, this.selectedDate, this.selectedTime.timeStart)
        // console.log("Response preBookTreatment: ", response.data)

        if(response.data == 'complete'){
          this.bookTreatment();
        }
        else{
          this.feedback.type = 'warning';
          this.feedback.icon = 'mdi-alert';
          this.feedback.message = this.$t('alert.treatmentTimeNoLongerAvailable');
        }
      })
      .catch(error=>{
        console.error("preBookTreatment error: ", error)
      })
    },

    getTreatmentsLocal(){
        this.events = [];

        // WEGHALEN ALS API GOED WERKT
        let events = [];
        let eventTreatments = [];

        this.treatmentTypes.push({
          category: "Voeding",
          id: "4Nn61Dhw879iu2TBI0cx",
          name:"Voeding",
          treatments: []
        })

        let todayTime = moment().format("YYYY-MM-DD" + "T" + "HH:mm");
        let bookingSummaries = [];
        db
        .collection("bookingsummary")
        // .where("companyId", "==", req.body.thriveCompany.companyId)
        .where("branch", "==", this.selectedBranch)
        .where("active", "==", true)
        .where("start", ">", todayTime)
        .where("type", "==", "eventbooking")
        .orderBy("start", "asc")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            let seatsNumber = null;
            let eventAvailability = null;
            if (doc.data().maxPersons > doc.data().registrations.length) {
              eventAvailability = doc.data().maxPersons - doc.data().registrations.length;
            }
            bookingSummaries.push({
              bookingSummaryId: doc.id, //Hoofd ID bookingsummary.
              eventSummaryId: doc.data().eventSummaryId,
              company: doc.data().company,
              companyId: doc.data().companyId,
              created: doc.data().created,
              createdby: doc.data().createdby,
              start: doc.data().start,
              selected: false,
              startFormatted: doc.data().start,
              end: doc.data().end,
              treatmentTitle: doc.data().title,
              treatmentShortDesc: doc.data().description,
              branch: doc.data().branch,
              type: doc.data().type,
              availability: eventAvailability,
              maxPersons: doc.data().maxPersons, //Maximaal aantal personen
              registrations: doc.data().registrations,
              showSeats: doc.data().showSeats,
            });
          });
        })
        .then(() => {
          if(bookingSummaries.length > 0) {
            let counter = 0;
            new Promise((resolve) => {
              bookingSummaries.forEach((event) => {
                db.collection("events")
                  .doc(event.eventSummaryId)
                  .get()
                  .then((doc) => {
                    let maxTimeLimitSubscription = event.maxTimeLimitSubscription ? event.maxTimeLimitSubscription : null; 
                    let minTimeLimitSubscription = event.minTimeLimitSubscription ? event.minTimeLimitSubscription : null;  

                    if (doc.data().eventType == "specialevent") {  
                      events.push({
                        //Alle Special Event
                        bookingSummaryId: event.bookingSummaryId,
                        eventSummaryId: doc.id, //Hoofd ID bookingsummary.
                        company: doc.data().company,
                        companyId: doc.data().companyId,
                        availability: event.availability,
                        maxPersons: event.maxPersons, //Maximaal aantal personen
                        registrations: event.registrations,
                        startFormatted: event.startFormatted,
                        end: event.end,
                        showSeats: event.showSeats,
                        maxTimeLimitSubscription: maxTimeLimitSubscription,
                        minTimeLimitSubscription:  minTimeLimitSubscription,
                        selected: false,
                        title: doc.data().title,
                        description: doc.data().description,
                        branch: doc.data().branch,
                        type: "event",
                      });
                    }
                    if (doc.data().eventType == "treatment") {
                      let treatment = {
                        bookingSummaryId: event.bookingSummaryId,
                        eventSummaryId: doc.id,
                        company: doc.data().company,
                        companyId: doc.data().companyId,
                        showSeats: event.showSeats,
                        maxTimeLimitSubscription: maxTimeLimitSubscription,
                        minTimeLimitSubscription:  minTimeLimitSubscription,
                        availability: event.availability,
                        selected: false,
                        startFormatted: event.startFormatted,
                        end: event.end,
                        maxPersons: event.maxPersons, //Maximaal aantal personen
                        registrations: event.registrations,
                        treatmentType: doc.data().treatmentType,
                        treatmentTitle: doc.data().title,
                        treatmentShortDesc: doc.data().description,
                        type: "event",
                      };
                      eventTreatments.push(treatment)
                    }
                  })
                  .then(() => {
                    counter++;
                    if (counter == bookingSummaries.length) {
                      resolve();
                    }
                  });
              })
            })
            .then(()=>{
              let eventsUniq = _.cloneDeep(_.uniqBy(events, 'eventSummaryId'));
              let eventTreatmentsUniq = _.cloneDeep(_.uniqBy(eventTreatments, 'eventSummaryId'));

              eventsUniq.forEach(uniqEvent=>{
                uniqEvent.events= [];
                events.forEach(event=>{
                  if(event.eventSummaryId == uniqEvent.eventSummaryId){
                    uniqEvent.events.push(event);
                  }
                })
              })

              eventTreatmentsUniq.forEach(uniqEvent=>{
                uniqEvent.events= [];
                eventTreatments.forEach(treatment=>{
                  if(treatment.eventSummaryId == uniqEvent.eventSummaryId){
                    uniqEvent.events.push(treatment);
                  }
                })
                let treatmenTypeIndex = _.findIndex(this.treatmentTypes, ["id", uniqEvent.treatmentType]);
                let treatmenTypeOverigIndex = _.findIndex(this.treatmentTypes, ["id", "others"]);
                this.treatments.push(uniqEvent);
                if ((treatmenTypeIndex) => 0) {
                  this.treatmentTypes[treatmenTypeIndex].treatments.push(uniqEvent);
                } else {
                  this.treatmentTypes[treatmenTypeOverigIndex].treatments.push(uniqEvent);
                }
              })

            })
            
            .catch((error) => {
              console.error("Error loading events", error);
            });
          }
        })
      
    },

    // sven

    async bookEvent(){
      await this.getClientData();
      console.log("this.clientId: ", this.clientId)
      this.feedback.message = null;
      let clientIdIndex = _.indexOf(this.selectedEvent.registrations, this.clientId);
      if(clientIdIndex < 0){
        this.selectedEvent.registrations.push(this.clientId)
        db.collection("bookingsummary")
        .doc(this.selectedEvent.bookingSummaryId)
        .update({
          registrations: this.selectedEvent.registrations
        })
        .then(()=>{
          this.completeConversionData();
          this.step = 5;
          // SEND CONFRIMATION EMAIL
          let lang = this.selectedLanguage.code.toLowerCase();
          axios
          //.get(`http://localhost:9993/confirmEvent?doc=${this.selectedEvent.bookingSummaryId}&activebranch=${this.selectedBranch}&clientId=${this.clientId}&lang=nl`)
          .get(`https://deliver.longevityze.nl/confirmEvent?doc=${this.selectedEvent.bookingSummaryId}&activebranch=${this.selectedBranch}&clientId=${this.clientId}&lang=nl`)
          .then((response) => {
            if (response) {
              //Email succesfully sent!
            }
          })
          .catch((error) => {
            console.error(error.message);
          });
        })
        .catch(error => {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
          this.apiError = {
            cacheId: this.cacheToken,
            log: "Event Booking error: " + JSON.stringify(error)
          };
          this.updateConversionData();
          this.feedback.type = 'error'
          this.feedback.icon = 'mdi-alert';
          this.feedback.message = this.$t('alert.bookingError');
        });
      } 
      else{
        this.feedback.type = 'warning';
        this.feedback.icon = 'mdi-alert';
        this.feedback.message = this.$t('alert.alreadySubscribed');
      }
    },

    async getClientData(){
       console.log("Client Check");
        const configAxiosPOST = {
          headers: {
            "Content-Type": "application/json",
          },
        };

        let jsonOBJ = {
          companyId: this.company,
          clientEmail: this.email,
          clientFirstName: this.firstName,
          clientLastName: this.lastName,
          clientPhone: `${this.selectedPhoneLanguage.phone}${this.tel}`,
        };

        console.log("jsonOBJ: ", jsonOBJ);

        await new Promise((resolve) => {
          axios
            .post(`https://api.thrive365.nl/postClientExist`, jsonOBJ, configAxiosPOST)
            .then((response) => {
              console.log(response.data);
              // Client does not exist
              if (response.data.typeExist == 2) {
                // Create Client
                let companies = [this.company.id];
                db.collection("clients")
                  .add({
                    name: this.firstName,
                    surname: this.lastName,
                    email: this.email,
                    companies: companies,
                    phone: `${this.selectedPhoneLanguage.phone}${this.tel}`,
                    gender: "",
                    emailSubscriptions: {
                      newsletter: false,
                    },
                    health: {
                      macronutrients: {},
                    },
                    address: {},
                    permissions: {},
                  })
                  .then((docRef) => {
                    this.clientId = docRef.id;
                    console.log("Client check finished");
                    resolve();
                  });
              }

              // Client bestaat al, maar nog niet bij dit bedrijf
              else if (response.data.typeExist == 1 && response.data.companySet == false) {
                // Set company in client doc
                let companies = null;
                db.collection("clients")
                  .doc(response.data.clientId)
                  .get()
                  .then((doc) => {
                    companies = doc.data().companies;
                    companies.push(this.company);
                  })
                  .then(() => {
                    db.collection("clients").doc(response.data.clientId).set(
                      {
                        companies: companies,
                      },
                      { merge: true }
                    );
                  })
                  .then(() => {
                    this.clientId = response.data.clientId;
                    console.log("Client check finished");
                    resolve();
                  });
              }

              // Client bestaat al, ook bij dit bedrijf
              else if (response.data.typeExist == 0 && response.data.companySet == true) {
                // Set client Id
                this.clientId = response.data.clientId;
                console.log("Client check finished");
                resolve();
              }
            })
            .catch((err) => {
              console.error("Error axios postClientExist =>", err);
              resolve();
            });
        })
        return 
    },



    bookTreatment(){
      // console.log("postdata: ", this.cacheToken, this.selectedTime.sector, this.selectedTime.uniqId)
      this.posting = true;
      let data = {
        "token": this.cacheToken,
        "type": this.downPaymentAmount == 0 ? 'booking' : 'downPaymentBooking', 
        "thriveBooking":{
          // "sector": this.selectedTime.sector,
          // "uniqId": this.selectedTime.uniqId,
          "confirmMail": this.downPaymentAmount == 0 ? 'true' : 'false'
        }
      };

      let config = {
        method: 'post',
        url: `${this.apiUrl}/postBooking`,
        headers: { 
          'Content-Type': 'application/json'
        },
        data : JSON.stringify(data)
      };

      axios(config)
      .then((response)=> {
        console.log("response.data booking: ", response)
        if(response.data.status == 200){

          this.completeConversionData();
          this.feedback.message = null;
          if(this.downPaymentAmount == 0){
            if(this.compdata.conversion && this.compdata.conversion.successUrl){
              let widgetObject = { message: "widgetKill", url: this.compdata.conversion.successUrl };
              
              parent.postMessage(widgetObject, "*")
              this.$emit("showWidgetDialog", false);
              this.resetWidgetData();
            }
            else{
              this.step = 5;
            }
            this.posting = false;
          }
          else{
            this.confirmBookingWithDownPayment(response.data.uniqIdStamp, response.data.clientId, 'downPayment')
          }  
        }
        else{
          if(response.data == 'Already taken'){
            this.feedback.type = 'warning';
            this.feedback.icon = 'mdi-alert';
            this.feedback.message = this.$t('alert.treatmentTimeNoLongerAvailable');
          }
          else{
            this.feedback.type = 'error'
            this.feedback.icon = 'mdi-alert';
            this.feedback.message = this.$t('alert.bookingError');
          }
          this.posting = false;
        }
        
        
      })
      .catch((error)=> {
        this.apiError = {
          cacheId: this.cacheToken,
          log: "postBooking error: " + JSON.stringify(error)
        };
        this.updateConversionData();
        console.error("Posting error: ", error)
      });
    },
     
    next(){
      // console.log("this.selectedTreatment (next): ", this.selectedTreatment)
      if(this.step == 0){
        // Personal info
        this.clientCacheLoading = true;
        if(this.selectedBranch){
          this.setClientCache().then(()=>{
            if(this.selectedBranch){
              if(this.actionType == 'shortcut'){
                let treatmentInList = _.findIndex(this.treatments, { 'id': this.preSelectedTreatmentData });
                if(this.preSelectedTreatment){
                  if(treatmentInList < 0){
                    this.treatments.push(this.preSelectedTreatmentData);
                    let treatmentTypeIndex = _.findIndex(this.treatmentTypes, {'id': this.preSelectedTreatmentData.treatmentType})
                    let treatmentTypeIndexOthers = _.findIndex(this.treatmentTypes, {'id': 'others'})
                    if(treatmentTypeIndex >= 0){
                      this.treatmentTypes[treatmentTypeIndex].treatments.push(this.preSelectedTreatmentData)
                    }
                    else if( treatmentTypeIndex < 0  && treatmentTypeIndexOthers >= 0){
                      this.treatmentTypes[treatmentTypeIndexOthers].treatments.push(this.preSelectedTreatmentData)
                    }
                    else{
                      let newType = {
                        name: "Overig",
                        category: "others",
                        id:"others",
                        treatments: [this.preSelectedTreatmentData]
                      }
                      this.treatmentTypes.push(newType)
                    }
                  }
                  // console.log("Step 0 select treatment")
                  this.selectTreatment('treatment', this.preSelectedTreatmentData, null, null)
                  this.nextToAvailability();
                }
                else{
                  this.step = 2;
                }
              }
              else{
                this.step = 2;
              }
            }
            else{
              this.step = 1;
            }
            this.clientCacheLoading = false;
          })
        }
        else {
          this.step = 1
        }  
        this.postConversionData();
      }
      else if(this.step == 1){
        // Select Branch
        this.setClientCache().then(()=>{
          this.availability = [];
          this.availabilityMonth = [];
          this.getBranchTreatments().then(()=>{
            if(this.actionType == 'shortcut'){
              let treatmentInList = _.findIndex(this.treatments, { 'id': this.preSelectedTreatmentData });
              if(this.preSelectedTreatment){
                if(treatmentInList < 0){
                  this.treatments.push(this.preSelectedTreatmentData);
                  let treatmentTypeIndex = _.findIndex(this.treatmentTypes, {'id': this.preSelectedTreatmentData.treatmentType})
                  let treatmentTypeIndexOthers = _.findIndex(this.treatmentTypes, {'id': 'others'})
                  if(treatmentTypeIndex >= 0){
                    this.treatmentTypes[treatmentTypeIndex].treatments.push(this.preSelectedTreatmentData)
                  }
                  else if( treatmentTypeIndex < 0  && treatmentTypeIndexOthers >= 0){
                    this.treatmentTypes[treatmentTypeIndexOthers].treatments.push(this.preSelectedTreatmentData)
                  }
                  else{
                    let newType = {
                      name: "Overig",
                      category: "others",
                      id:"others",
                      treatments: [this.preSelectedTreatmentData]
                    }
                    this.treatmentTypes.push(newType)
                  }
                }
                
                // console.log("Step 1 select treatment")
                this.selectTreatment('treatment', this.preSelectedTreatment, null, null)
                this.nextToAvailability();
                
              }
              else{
                this.step = 2;
              }
            }
            else{
              this.step = 2;
            }
          })
        })    
      }
      else if(this.step == 2){
        // Select treatment
        if(this.selectedTreatment.event){ // Treatment is Event
          this.step = 3;
        }
        else if(this.selectedTreatment.eventBooking){ // Treatment is eventBooking / Grouplesson
          this.nextToAvailability();
        }
        else{
          this.nextToAvailability();
        }
      }
      else{
        this.step++
      }
    },

    stepBack(){
      if(this.step == 2 && this.selectedBranch){
        this.step = 0;
      }
      else if(this.step == 3 ){
        this.step--;
        this.startFrom = 0;
        this.selectedEmployee = 0;
        this.selectedEmployeeData = {
          id: 0,
          name: "Geen voorkeur"
        };
        this.availabilityLoading = false;
        this.availability = [];
        this.availabilityMonth = [];
        this.selectedEvent = null;;
        this.selectedDate = null;
        this.selectedSector = null;
        this.selectedTime = null;
      } 
      else{
        this.step--;
        this.feedback.message = null;
      }
    },
    
    nextToAvailability(){
      if(this.availability.length == 0 && !this.availabilityLoading){
        this.availabilityLoading = true;
        if(!this.selectedTreatment.eventBooking){ // Treatment
          // console.log("treatment")
          this.getEmployees().then((result)=>{
            if(result){
              this.getAvailability(0, 'new')
            }
          })
        }
        else{ // Event Booking
          // console.log("bookingEvent")
          this.getAvailability(0, 'new')
        }    
      }
      else{
        // console.log("ELSE PROBLEEM")
      }
      this.calculateDownPaymentAmount();
      this.step = 3;
      this.checkWindowDates();
    },
  
    postConversionData(){
      if(this.docId){
        this.updateConversionData();
      }
      else{
        db.collection("conversion")
        .add({
          timestamp: new Date(),
          companyId: this.company,
          type: "bookingwidget",
          clientData: {
            existingClient: this.existingClient,
            name: this.firstName + " " + this.lastName,
            id: this.clientId,
            email: this.email,
            phone: this.selectedPhoneLanguage.phone + this.tel,
            device: this.userAgent,
            userAgent: navigator.userAgent,
            language: this.selectedLanguage.id,
            ip: this.ip,
          },
          widgetData: {
            error: this.apiError,
          },
          progress: {
            availableForAction: true,
            completed: false
          },
          value: null,
          source: this.source,
          startUrl: this.startUrl,
          executedFrom: this.executedFrom,
        })
        .then(docRef => {
          this.docId = docRef.id;
        })
        .catch(error=>{
          console.error("Error postConversionData: ", error)
        });
      }
      
    },

    updateConversionData(){
      let date = this.selectedDate  ? this.selectedDate : null;
      let time = (this.selectedTime && this.selectedTime.timeStart) ? this.selectedTime.timeStart : null;
      let selectedTreatments = (this.selectedTreatment && this.selectedTreatment.treatmentsData && this.selectedTreatment.treatmentsData.length > 0) ? this.selectedTreatment.treatmentsData : null;
      let selectedEvent = this.selectedEvent ? this.selectedEvent : null;

      db.collection("conversion")
        .doc(this.docId)
        .set({
            clientData: {
              existingClient: this.existingClient,
              name: this.firstName + " " + this.lastName,
              id: this.clientId,
              email: this.email,
              phone: this.selectedPhoneLanguage.phone + this.tel,
              language: this.selectedLanguage.id
            },
            widgetData: {
              error: this.apiError,
              employee: {
                id: this.selectedEmployee,
                name: this.selectedEmployeeData.name
              },
              branch: {
                id: this.selectedBranch,
                name: this.selectedBranchData.name
              },
              treatments: this.selectedTreatment.treatmentsData,
              event: selectedEvent,
              date: date,
              time: time,
              closeReason: null
            },
            timestampUpdated: new Date(),
            value: {
              number: this.totalTreatmentPrice,
              type: "amount"
            }
          },
          { merge: true }
        )
        .then(()=>{
          console.log("Conversion updated")
        })
        .catch(error=>{
          console.error("Error updateConversionData: ", error)
        });
    },

    completeConversionData(){
      db.collection("conversion")
        .doc(this.docId)
        .set({
            progress: {
              availableForAction: false,
              completed: true,
              completedBy: "client",
              completedOn: new Date(),
            },
            timestampUpdated: new Date(),
          },
          { merge: true }
        )
        .catch(error=>{
          console.error("Error completeConversionData: ", error)
        });
    }
  },

  computed: {
    noTreatmentsSelected(){
      if(this.step == 2){
        if(this.selectedTreatment.treatments.length == 0 && !this.selectedTreatment.event){
          return true;
        }
        else{
          return false;
        }
      }
      else{
        return false;
      }
    },

    treatmentTypesFiltered(){
      let treatmentTypesFiltered = [];

      if(this.treatmentSearch && this.treatmentSearch.length > 0){
        treatmentTypesFiltered = {
          treatments: [],
          events: []
        };
        this.selectedGender = 'all';
        this.treatments.forEach(treatment=>{
          if(treatment.treatmentShortDesc.toLowerCase().includes(this.treatmentSearch.toLowerCase()) || treatment.treatmentTitle.toLowerCase().includes(this.treatmentSearch.toLowerCase())){
            treatmentTypesFiltered.treatments.push(treatment)
          }
        })
        this.events.forEach(event=>{
          if(event.description.toLowerCase().includes(this.treatmentSearch.toLowerCase()) || event.title.toLowerCase().includes(this.treatmentSearch.toLowerCase())){
            treatmentTypesFiltered.events.push(event)
          }
        })
        return treatmentTypesFiltered;
      }
      else{
        if(this.treatmentTypes.length > 0){
          this.loadingTreatments = true;
          if(this.seperateTreatments && (this.selectedGender == 'male' || this.selectedGender == 'female')){
            this.treatmentTypes.forEach(treatmentType=>{
              let treatmentTypeByGender = _.cloneDeep(treatmentType);
              treatmentTypeByGender.treatments = [];
              treatmentType.treatments.forEach(treatment =>{
                if(treatment.treatmentGender == this.selectedGender){
                  treatmentTypeByGender.treatments.push(treatment)
                }
              })
              if(treatmentTypeByGender.treatments.length > 0){
                treatmentTypesFiltered.push(treatmentTypeByGender) 
              }
            })
            this.loadingTreatments = false;
            return treatmentTypesFiltered;
          } 
          else{
            this.treatmentTypes.forEach(treatmentType=>{
              treatmentTypesFiltered.push(treatmentType)
            })
            this.loadingTreatments = false;
            return treatmentTypesFiltered;
          }
        }
        else {
          return [];
        }
      }
    },

    buttonColorFemale(){
      if(this.selectedGender == 'female' ){
       return false;
      }
      else{
        return true;
      }
    },

    buttonColorMale(){
      if(this.selectedGender == 'male' ){
       return false;
      }
      else{
        return true;
      }
    },

    buttonColorAll(){
      if(this.selectedGender == 'all' ){
       return false;
      }
      else{
        return true;
      }
    },

    noMoreDates(){
      if(this.availability.length > 0){
        if(this.availabilityMargin <= ((this.availability.length - this.windowDates) * -63)){
          return true;
        }
        else{ 
          return false;
        }
      }
      else{ 
        return false;
      }
    },

    widgetLanguages(){
      let languages = [];
      this.languages.forEach(language=>{
        if(language.code == 'NL' || language.code == 'EN' ){
          languages.push(language)
        }
      });
      return languages;
    },

    valid(){
      if(this.step == 0){
        if(this.clientInformationValid && this.nextStepEnabled){
          return true;
        }
      }
      else if(this.step == 1){
        if(this.selectedBranch){
          return true;
        }
      }
      else if(this.step == 2){
        if(this.selectedTreatment.treatments.length > 0 || this.selectedTreatment.event){
          return true;
        }
      }
      else{
        return false
      }
    }
  }
};
</script>
<style>
  .pre-selected-treatment-wrapper{
    padding: 10px;
    background-color: var(--v-background-base);
    border-bottom: 1px solid rgba(0,0,0 ,0.07);
  }
  .pre-selected-treatment-wrapper h3,
  .pre-selected-treatment-wrapper p{
    text-align: center;
    margin: 0!important;
  }
  .pre-selected-treatment-time{
    font-style: italic;
    font-size: 14px;
  }
  
  .widget-card{
    position: relative;
    overflow: hidden;
    border-radius: 0!important;
  }
  .widget-list{
    border-bottom: 1px solid rgba(0,0,0 ,0.12);
  }
  .treatment-type-title{
    border-bottom: 1px solid rgba(0,0,0 ,0.07);
    background-color: #f9f9f9;
    height: 34px;
  }
  .treatment-type-title h3{
    border-bottom: 1px solid rgba(0,0,0 ,0.07);
    background-color: #f9f9f9;
    text-transform: uppercase;
    font-weight: 400;
    font-size: 14px;
    line-height: 34px;
    padding: 0 8px;
  }
  

  .treatment-list{
    border-bottom: 1px solid rgba(0,0,0 ,0.07);
    /* background-color: #f9f9f9; */
  }
  .treatment-description{
    font-size: 14px;
    padding: 4px 0;
  }

  .treatment-time{
    font-size: 12px;
    color: #444444!important;
  }

  .treatment-list.selected{
    background-color:rgba(0,0,0 ,0.12);
    border: none;
  }
  .widget-list.selected{
    background-color:rgba(0,0,0 ,0.05);
    border: none;
  }
  .widget-header{
    height: 52px;
    width: 100%;
    border-radius: 0;
    position: absolute;
    top: 0;
    z-index: 2;
    /* -webkit-box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12); */
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.37);
  }

  .widget-header-inner{
    padding: 8px 4px;
    height: 52px;
  }

  .widget-header-inner::after{
    display: block;
    content:"";
    clear: both;
  }

  .widget-header-previous{
    width: 72px;
    height: 36px;
    float: left;
  }

  .widget-header-title{
    width: calc(100% - 144px);
    height: 36px;
    float: left;
  }

  .notification-header-title{
    width: 100%;
  }

  .notification-header-title h2,
  .widget-header-title h2{
    font-size: 22px;
    line-height: 36px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
  }

  .title-primary{
    background-color: var(--v-primary-base);
  }

  @media only screen and (max-width: 680px) {
    .widget-header-title h2{
      font-size: 18px;
    }
  } 

  .widget-header-language{
    width: 36px;
    height: 36px;
    float: left;
    padding: 8px 3px;
  }

  .widget-header-close{
    width: 36px;
    height: 36px;
    float: left;
    text-align: right;
  }

  .v-menu__content.custom-shape-menu{
    border-radius: 0!important;
  }


  .terms-wrapper{
    overflow:hidden;
    border-radius: 0px;
  }
  .terms-header{
    height: 50px;
    padding: 5px;
    background: #333;
    color: #fff;
    width: 100%;
  }

  .terms-content{
    background-color: #f1f1f1;
    padding: 10px;
    width: 100%;
    overflow-y: scroll;
  }

  .widget-content{
    position: absolute;
    margin-top: 52px;
    width: 100%;
    overflow: scroll;
    z-index: 1;
    scroll-behavior: smooth;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }

  #widget{
    contain: content;
    will-change: transform;
  }

  #widget-content::-webkit-scrollbar {
    display: none;
  }
 
  .widget-content.remove-padding{
    padding: 0;
  }

  .widget-footer{
    padding: 5px; 
    height: 80px;
    width: 100%;
    position: absolute;
    bottom: 0;
    margin: 0;
    background-color: #ffffff;
    box-shadow: 0px 0px 15px -8px rgba(0, 0, 0, 0.37);
    z-index: 2;
    transition: margin 250ms;
  }
  .widget-footer.hide{
    margin: 0 0 -90px 0;
    transition: margin 250ms;
  }

  .custom-list{
    padding: 0!important;
    margin: 0!important;
  }
  
  .widget-language-flag{
    width: 30px;
    height: 20px;
    background-color: #f1f1f1;
  }

  .widget-language-flag.nl {
    background: url("../assets/flags/dutch-flag.png") no-repeat center center;
    background-size: 30px 20px;
  }
  .widget-language-flag.gb,
  .widget-language-flag.en {
    background: url("../assets/flags/uk-flag.png") no-repeat center center;
    background-size: 30px 20px;
  }

  .phone-lang-select .v-input__slot{
    padding-left: 0!important;
  }

  .treatments{
    padding-bottom: 0px;
  }

  .treatments.selected{
    padding-bottom: 90px;
  }

  .treatment-price{
    font-size: 22px;
    font-weight: bold;
  }
  .treatment-price.summary{
    font-size: 18px;
    font-weight: normal;
  }
  .treatment-price.summary.total{
    font-size: 18px;
    font-weight: bold;
  }
  .treatment-price.empty{
    font-size: 20px;
    font-weight: normal;
  }

  .pricing-footer{
    font-size: 22px;
    font-weight: bold;
  }

  @media only screen and (max-width: 401px) {
    .pricing-footer{
      font-size: 18px;
      font-weight: bold;
    }
  }

  .run-animation {
    animation: fancy-animation 0.5s; 
  }

  @-webkit-keyframes fancy-animation {
    0% { 
      font-size: 22px;
      text-shadow: none;
    }
    50% { 
      font-size: 26px;
      text-shadow: 0 0 5px #c1c9d7; 
    }
    100% { 
      font-size: 22px;
      text-shadow: none; 
    }
  }
  /*

   */

   .date-select-header{
     padding: 24px 12px 80px 12px; 
     background-color: #f6f7fb;
   }

   .date-select-header.month{
     padding: 24px 12px 75px 12px; 
   }

  .widget-dates-monthview-header:after{
    clear: both;
    display: block;
    content: "";
  }

  .widget-view-month{
    width: calc(100% - 66px);
    color: #0d1f31;
    font-weight: bold;
    float: left;
    text-align: center;
    text-transform: capitalize;
  }

  .widget-dates-monthview-dates{
    padding: 0 33px;
  }

  .widget-date-time-wrapper{
    margin: -60px 0 0 0;
  }

  .widget-dates-outer-wrapper{
    margin: 0 auto;
  }

  .widget-dates-outer-wrapper:after,
  .timeslots-wrapper:after{
    display: block;
    content: "";
    clear: both;
  } 

  .widget-dates-previous,
  .widget-dates-next{
    width: 33px; 
    padding: 38px 0 0 1px;
    float: left;
    min-height: 10px;
  }

  .widget-dates-monthview-header .widget-dates-previous,
  .widget-dates-monthview-header .widget-dates-next{
    width: 33px; 
    padding: 0;
    float: left;
  }

  .widget-dates-previous{
    padding: 38px 2px 0 0;
  }

  #widget-dates-wrapper{
    float: left;
    height: 115px;
    width: calc(100% - 69px);
    overflow: hidden;
  }

  .widget-dates{
    transition: margin 550ms;
  }

  .widget-dates{
    display: block;
    content: "";
    clear: both;
  }
  

  .date-item{
    background-color: #ffffff;
    border-radius: 60px;
    padding: 12px 5px 8px 5px; 
    width: 54px;
    margin: 10px 5px 10px 4px; 
    float: left; 
    position: relative;
    text-align: center;
    text-decoration: none;
    display: block;
    color: #0d1f31;
    box-shadow: 0 1px 5px rgba(193,201,215, 0.5);
    overflow: hidden;
  }

  .widget-date-time-wrapper .date-item{
    border: 1px solid rgba(193,201,215, 1);
    border-radius: 15px;
    padding: 6px 5px 2px 5px; 
    margin: 6px 5px 4px 4px; 
   }

  @media only screen and (max-width: 401px) {
    .date-item{
      width: 50px;
    }
  }

  .date-item.today{
    background-color: #00adef;
  }

  .date-item.empty:after{
    display: block;
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 60px;
    padding: 12px 5px 8px 5px; 
    width: 54px;
    height: 86px;
    background: repeating-linear-gradient(
      45deg,
      rgba(255,255,255,0.2),
      rgba(255,255,255,0.2) 3px,
      rgba(193,201,215, 0.7) 3px,
      rgba(193,201,215, 0.7) 6px
    );
  }

  .date-item.today.empty:after{
    display: block;
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 60px;
    padding: 12px 5px 8px 5px; 
    width: 54px;
    height: 86px;
    background: repeating-linear-gradient(
      45deg,
      rgba(255,255,255,0.2),
      rgba(255,255,255,0.2) 3px,
      rgba(255,255,255, 0.7) 3px,
      rgba(255,255,255, 0.7) 6px
    );
  }
  .widget-date-time-wrapper .date-item.empty:after,
  .widget-date-time-wrapper .date-item.today.empty:after{
    border-radius: 15px;
  }

  .date-item.selected,
  .date-item.selected > *,
  .date-item:hover,
  .date-item:hover > *{
    background-color: #0d1f31;
    color: #fff!important;
    cursor: pointer!important;

  }

  .widget-date-time-wrapper .date-item.selected,
  .widget-date-time-wrapper .date-item.selected > *,
  .widget-date-time-wrapper .date-item:hover,
  .widget-date-time-wrapper .date-item:hover > *{
    background-color: #0d1f31;
    color: #fff!important;
    cursor: pointer!important;
  }

  .date-item.empty:hover{
    background-color: #ffffff;
    cursor: not-allowed!important;
  }

  .date-item.today.empty:hover{
    background-color: #00adef;
  }

  .date-item.empty:hover .day-text,
  .date-item.empty:hover .month{
    color: #c1c9d7!important;
    background-color: #ffffff;
  }

   .widget-date-time-wrapper .date-item.empty:hover .day-text{
      color: #0d1f31!important;
      z-index: 999;
   }

  .date-item.today.empty:hover .day-text,
  .date-item.today.empty:hover .day-number,
  .date-item.today.empty:hover .month{
    color: #ffffff!important;
    background-color: #00adef;
    cursor: not-allowed!important;
  }

  .date-item.empty:hover .day-number{
    color: #0d1f31!important;
    background-color: #ffffff;
  }

  .date-item > *{
    cursor: pointer!important;
  }

  .date-item .day-text{
    font-size: 11px;
    color: #0d1f31;
    text-transform: uppercase;
  }
  .date-item .day-number{
    font-size: 22px;
    font-weight: bold;
    color: #0d1f31;
  }
  .date-item .month{
    font-size: 11px;
    color: #c1c9d7;
    text-transform: uppercase;
  }

  .date-item.today .day-text,
  .date-item.today .day-number,
  .date-item.today .month{
    color: #ffffff
  }

  .widget-date-time-wrapper .date-item .day-text{
    font-size: 10px;
  }

  .widget-date-time-wrapper .date-item .day-number{
    font-size: 20px;
  }

  .widget-date-time-wrapper .date-item .month{
    display: none;
  }

  /* EVENTS */ 

  .event-availability-heading{
    padding: 24px 12px 80px 12px; 
    background-color: #f6f7fb;
    color: #0d1f31;
  }

  .event-availability-events{
    margin: -72px 0 0 0;
  }


  .event-card-wrapper{
    background-color: #ffffff;
    border-radius: 8px!important;
    position: relative;
    text-align: left;
    display: block;
    color: #0d1f31;
    box-shadow: 0 1px 5px rgba(193,201,215, 0.5)!important;
    overflow: hidden;
  }

  .event-card-wrapper h3{
    color: #0d1f31;
  }

  .event-card-wrapper h3 .day{
    color: #0d1f31;
    text-transform: capitalize;
   }

  .event-card-wrapper p{
    color: #0d1f31;
    margin: 0 0 5px 0!important;
  }

  /* TIMESLOTS */ 
  .timeslots-wrapper{
    margin: 10px auto;
  }

  .time-item{
    border: 1px solid rgba(193,201,215, 1);
    background-color: #ffffff;
    border-radius: 50px;
    padding: 5px; 
    width: 99px;
    margin: 6px; 
    float: left; 
    text-align: center;
    text-decoration: none;
    display: block;
    color: #0d1f31!important;
    box-shadow: 0 1px 5px rgba(193,201,215, 0.5);
    overflow: hidden;
    cursor: pointer!important;
  }

  .time-item:hover{
    background-color: #0d1f31!important;
    color: #ffffff!important;
    border: 1px solid #0d1f31;
    cursor: pointer!important;
  }

  .selected-treatments-label{
    font-size: 14px; 
    font-style: italic;
  }

  @media only screen and (max-width: 401px) {
    .time-item{
      width: 88px;
    }
    .selected-treatments-label{
      font-size: 12px; 
    }
  }

  @media only screen and (max-width: 321px) {
    .time-item{
      padding: 2px;
      width: 63px;
      font-size: 15px;
    }
  }

  .total-price-wrapper{
    height: 50px;
  }

  .total-price-wrapper:after{
    display: block;
    content: "";
    clear: both;
  } 

  #total-price{
    display: block;
    height: 40px;
    line-height: 35px;
    float: left;
  }
  .total-label{
    display: block;
    float: left;
    height: 40px;
    padding: 8px 0 0 0;
    margin: 0 5px 0 0;
  }

  .first-possibility{
    text-align: center;
    padding: 20px 8px;
    margin: 20px 0 0 0;
  }
  .first-possibility-date{
    text-decoration: underline;
    font-weight: bold;
    color: #102234;
  }
  .first-possibility-date:hover{
    cursor: pointer;
  }

  .possibilities-wrapper{
    padding: 5px 0;
    margin: 20px 0 0 0;
    background-color: #f6f7fb;
  }

  .selected-date{
    text-align: center;
    padding: 8px 8px 0 8px;
    margin: 0!important;
  }

  .treatment-summary-wrapper{
    color: #0d1f31;
    border-bottom: 1px solid rgba(0,0,0 ,0.07);
  }

  .company-info{
    color: #0d1f31;
    font-size: 16px
  }
  .company-name{
    color: #0d1f31;
    font-size: 20px
  }
  .company-branch-name{
    color: #a4aec4;
    font-size: 20px
  }

  .confirm-email-text{
    font-size: 16px;
    color: #0d1f31;
  }
</style>
